// @generated by protoc-gen-es v1.10.1 with parameter "target=ts"
// @generated from file src/protos/learning_management/lms.assessment.student.apis.proto (package geneo.lms.assessment.student.apis, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import type { BinaryReadOptions, FieldList, JsonReadOptions, JsonValue, PartialMessage, PlainMessage } from "@bufbuild/protobuf";
import { Message, proto3, protoInt64, Timestamp } from "@bufbuild/protobuf";
import { AssessmentEnum, AssessmentSessionModeEnum, AssignmentConfigInfo, AttemptStats, AttemptTypeEnum, CloudUpload, IdleTimeInformation, MetricsModel, ModeOfConductionEnum, MultiSubjectSection, SessionModeEnum, SessionStatusEnum, StudentAssessmentResponse, StudentContentResponse, StudentPracticalResponse, StudentProjectSessionMetrics, StudentResourceSessionMetrics, SubmissionType, TaskActiveStatusEnum, TaskEnum, TaskEvaluationStatusEnum, TaskMetaInfo, TaskProjectProgress, TaskStudentAttemptStatusEnum, TaskTeacherReview, TimeStampWithKey } from "@protos/learning_management/lms.db_pb";
import { DifficultyLevelEnum, Module_ModuleCategoryEnum, PracticalProject, Resource_ResourceEnum, ResourceCategoryEnum } from "@protos/content_management/content.db_pb";
import { UploadFileResponse } from "@protos/learning_management/lms.hw.student.apis_pb";
import { AcademicYear_Enum, Subject_SubjectEnum } from "@protos/common/common.db_pb";

/**
 * @generated from enum geneo.lms.assessment.student.apis.AssessmentListEnum
 */
export enum AssessmentListEnum {
  /**
   * @generated from enum value: ASSESSMENT_UNDEFINED = 0;
   */
  ASSESSMENT_UNDEFINED = 0,

  /**
   * @generated from enum value: ASSESSMENT_ACTIVE = 1;
   */
  ASSESSMENT_ACTIVE = 1,

  /**
   * @generated from enum value: ASSESSMENT_ENDED = 2;
   */
  ASSESSMENT_ENDED = 2,
}
// Retrieve enum metadata with: proto3.getEnumType(AssessmentListEnum)
proto3.util.setEnumType(AssessmentListEnum, "geneo.lms.assessment.student.apis.AssessmentListEnum", [
  { no: 0, name: "ASSESSMENT_UNDEFINED" },
  { no: 1, name: "ASSESSMENT_ACTIVE" },
  { no: 2, name: "ASSESSMENT_ENDED" },
]);

/**
 * @generated from enum geneo.lms.assessment.student.apis.GilProjectStatusEnum
 */
export enum GilProjectStatusEnum {
  /**
   * @generated from enum value: GIL_PROJECT_STATUS_UNDEFINED = 0;
   */
  GIL_PROJECT_STATUS_UNDEFINED = 0,

  /**
   * @generated from enum value: GIL_PROJECT_STATUS_NOT_STARTED = 1;
   */
  GIL_PROJECT_STATUS_NOT_STARTED = 1,

  /**
   * @generated from enum value: GIL_PROJECT_STATUS_IN_PROGRESS = 2;
   */
  GIL_PROJECT_STATUS_IN_PROGRESS = 2,

  /**
   * @generated from enum value: GIL_PROJECT_STATUS_COMPLETED = 3;
   */
  GIL_PROJECT_STATUS_COMPLETED = 3,
}
// Retrieve enum metadata with: proto3.getEnumType(GilProjectStatusEnum)
proto3.util.setEnumType(GilProjectStatusEnum, "geneo.lms.assessment.student.apis.GilProjectStatusEnum", [
  { no: 0, name: "GIL_PROJECT_STATUS_UNDEFINED" },
  { no: 1, name: "GIL_PROJECT_STATUS_NOT_STARTED" },
  { no: 2, name: "GIL_PROJECT_STATUS_IN_PROGRESS" },
  { no: 3, name: "GIL_PROJECT_STATUS_COMPLETED" },
]);

/**
 * @generated from enum geneo.lms.assessment.student.apis.GilAttentionTypeEnum
 */
export enum GilAttentionTypeEnum {
  /**
   * @generated from enum value: GIL_ATTENTION_TYPE_UNDEFINED = 0;
   */
  GIL_ATTENTION_TYPE_UNDEFINED = 0,

  /**
   * Assigned for 7+ days and no member has opened the project.
   *
   * @generated from enum value: GIL_ATTENTION_TYPE_NOT_STARTED = 1;
   */
  GIL_ATTENTION_TYPE_NOT_STARTED = 1,

  /**
   * Started, not submitted, and no sitting for 14 days.
   *
   * @generated from enum value: GIL_ATTENTION_TYPE_STALLED = 2;
   */
  GIL_ATTENTION_TYPE_STALLED = 2,

  /**
   * Past the due date and not submitted.
   *
   * @generated from enum value: GIL_ATTENTION_TYPE_OVERDUE = 3;
   */
  GIL_ATTENTION_TYPE_OVERDUE = 3,

  /**
   * Submitted but not yet reviewed by the teacher.
   *
   * @generated from enum value: GIL_ATTENTION_TYPE_UNGRADED = 4;
   */
  GIL_ATTENTION_TYPE_UNGRADED = 4,

  /**
   * Not submitted, 3+ failed connects/flashes and no successful flash: likely a
   * kit, cable or driver problem rather than a learning one.
   *
   * @generated from enum value: GIL_ATTENTION_TYPE_HARDWARE_BLOCKED = 5;
   */
  GIL_ATTENTION_TYPE_HARDWARE_BLOCKED = 5,
}
// Retrieve enum metadata with: proto3.getEnumType(GilAttentionTypeEnum)
proto3.util.setEnumType(GilAttentionTypeEnum, "geneo.lms.assessment.student.apis.GilAttentionTypeEnum", [
  { no: 0, name: "GIL_ATTENTION_TYPE_UNDEFINED" },
  { no: 1, name: "GIL_ATTENTION_TYPE_NOT_STARTED" },
  { no: 2, name: "GIL_ATTENTION_TYPE_STALLED" },
  { no: 3, name: "GIL_ATTENTION_TYPE_OVERDUE" },
  { no: 4, name: "GIL_ATTENTION_TYPE_UNGRADED" },
  { no: 5, name: "GIL_ATTENTION_TYPE_HARDWARE_BLOCKED" },
]);

/**
 * @generated from enum geneo.lms.assessment.student.apis.GilTelemetryStatusEnum
 */
export enum GilTelemetryStatusEnum {
  /**
   * @generated from enum value: GIL_TELEMETRY_STATUS_UNDEFINED = 0;
   */
  GIL_TELEMETRY_STATUS_UNDEFINED = 0,

  /**
   * Read from the events service.
   *
   * @generated from enum value: GIL_TELEMETRY_STATUS_AVAILABLE = 1;
   */
  GIL_TELEMETRY_STATUS_AVAILABLE = 1,

  /**
   * This deployment has no events service configured.
   *
   * @generated from enum value: GIL_TELEMETRY_STATUS_NOT_CONFIGURED = 2;
   */
  GIL_TELEMETRY_STATUS_NOT_CONFIGURED = 2,

  /**
   * The events service failed or timed out; coding figures are unknown.
   *
   * @generated from enum value: GIL_TELEMETRY_STATUS_UNAVAILABLE = 3;
   */
  GIL_TELEMETRY_STATUS_UNAVAILABLE = 3,
}
// Retrieve enum metadata with: proto3.getEnumType(GilTelemetryStatusEnum)
proto3.util.setEnumType(GilTelemetryStatusEnum, "geneo.lms.assessment.student.apis.GilTelemetryStatusEnum", [
  { no: 0, name: "GIL_TELEMETRY_STATUS_UNDEFINED" },
  { no: 1, name: "GIL_TELEMETRY_STATUS_AVAILABLE" },
  { no: 2, name: "GIL_TELEMETRY_STATUS_NOT_CONFIGURED" },
  { no: 3, name: "GIL_TELEMETRY_STATUS_UNAVAILABLE" },
]);

/**
 * @generated from message geneo.lms.assessment.student.apis.GetStudentAssessmentListRequest
 */
export class GetStudentAssessmentListRequest extends Message<GetStudentAssessmentListRequest> {
  /**
   * @generated from field: int64 student_id = 1;
   */
  studentId = protoInt64.zero;

  /**
   * @generated from field: optional int32 page_number = 2;
   */
  pageNumber?: number;

  /**
   * @generated from field: optional int32 subject_id = 3;
   */
  subjectId?: number;

  /**
   * @generated from field: optional geneo.lms.db.AssessmentEnum assessment_type = 4;
   */
  assessmentType?: AssessmentEnum;

  /**
   * @generated from field: optional geneo.lms.assessment.student.apis.AssessmentListEnum assessment_list_type = 5;
   */
  assessmentListType?: AssessmentListEnum;

  constructor(data?: PartialMessage<GetStudentAssessmentListRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "geneo.lms.assessment.student.apis.GetStudentAssessmentListRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "student_id", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 2, name: "page_number", kind: "scalar", T: 5 /* ScalarType.INT32 */, opt: true },
    { no: 3, name: "subject_id", kind: "scalar", T: 5 /* ScalarType.INT32 */, opt: true },
    { no: 4, name: "assessment_type", kind: "enum", T: proto3.getEnumType(AssessmentEnum), opt: true },
    { no: 5, name: "assessment_list_type", kind: "enum", T: proto3.getEnumType(AssessmentListEnum), opt: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetStudentAssessmentListRequest {
    return new GetStudentAssessmentListRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetStudentAssessmentListRequest {
    return new GetStudentAssessmentListRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetStudentAssessmentListRequest {
    return new GetStudentAssessmentListRequest().fromJsonString(jsonString, options);
  }

  static equals(a: GetStudentAssessmentListRequest | PlainMessage<GetStudentAssessmentListRequest> | undefined, b: GetStudentAssessmentListRequest | PlainMessage<GetStudentAssessmentListRequest> | undefined): boolean {
    return proto3.util.equals(GetStudentAssessmentListRequest, a, b);
  }
}

/**
 * @generated from message geneo.lms.assessment.student.apis.GetStudentAssessmentListResponse
 */
export class GetStudentAssessmentListResponse extends Message<GetStudentAssessmentListResponse> {
  /**
   * @generated from field: int32 status = 1;
   */
  status = 0;

  /**
   * @generated from field: string code = 2;
   */
  code = "";

  /**
   * @generated from field: string message = 3;
   */
  message = "";

  /**
   * @generated from field: geneo.lms.assessment.student.apis.StudentAssessmentList data = 4;
   */
  data?: StudentAssessmentList;

  constructor(data?: PartialMessage<GetStudentAssessmentListResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "geneo.lms.assessment.student.apis.GetStudentAssessmentListResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "status", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 2, name: "code", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "message", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "data", kind: "message", T: StudentAssessmentList },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetStudentAssessmentListResponse {
    return new GetStudentAssessmentListResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetStudentAssessmentListResponse {
    return new GetStudentAssessmentListResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetStudentAssessmentListResponse {
    return new GetStudentAssessmentListResponse().fromJsonString(jsonString, options);
  }

  static equals(a: GetStudentAssessmentListResponse | PlainMessage<GetStudentAssessmentListResponse> | undefined, b: GetStudentAssessmentListResponse | PlainMessage<GetStudentAssessmentListResponse> | undefined): boolean {
    return proto3.util.equals(GetStudentAssessmentListResponse, a, b);
  }
}

/**
 * @generated from message geneo.lms.assessment.student.apis.StudentAssessmentList
 */
export class StudentAssessmentList extends Message<StudentAssessmentList> {
  /**
   * @generated from field: int64 student_id = 1;
   */
  studentId = protoInt64.zero;

  /**
   * @generated from field: geneo.lms.assessment.student.apis.StudentAssessments all_assessment = 2;
   */
  allAssessment?: StudentAssessments;

  /**
   * @generated from field: optional geneo.lms.assessment.student.apis.StudentAssessCountInfo assessment_list_info = 3;
   */
  assessmentListInfo?: StudentAssessCountInfo;

  constructor(data?: PartialMessage<StudentAssessmentList>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "geneo.lms.assessment.student.apis.StudentAssessmentList";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "student_id", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 2, name: "all_assessment", kind: "message", T: StudentAssessments },
    { no: 3, name: "assessment_list_info", kind: "message", T: StudentAssessCountInfo, opt: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): StudentAssessmentList {
    return new StudentAssessmentList().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): StudentAssessmentList {
    return new StudentAssessmentList().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): StudentAssessmentList {
    return new StudentAssessmentList().fromJsonString(jsonString, options);
  }

  static equals(a: StudentAssessmentList | PlainMessage<StudentAssessmentList> | undefined, b: StudentAssessmentList | PlainMessage<StudentAssessmentList> | undefined): boolean {
    return proto3.util.equals(StudentAssessmentList, a, b);
  }
}

/**
 * @generated from message geneo.lms.assessment.student.apis.StudentAssessCountInfo
 */
export class StudentAssessCountInfo extends Message<StudentAssessCountInfo> {
  /**
   * @generated from field: int32 total_assessment_count = 1;
   */
  totalAssessmentCount = 0;

  /**
   * @generated from field: int32 active_assessment_count = 2;
   */
  activeAssessmentCount = 0;

  /**
   * @generated from field: int32 ended_assessment_count = 3;
   */
  endedAssessmentCount = 0;

  /**
   * @generated from field: int32 count_in_pagination = 4;
   */
  countInPagination = 0;

  constructor(data?: PartialMessage<StudentAssessCountInfo>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "geneo.lms.assessment.student.apis.StudentAssessCountInfo";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "total_assessment_count", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 2, name: "active_assessment_count", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 3, name: "ended_assessment_count", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 4, name: "count_in_pagination", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): StudentAssessCountInfo {
    return new StudentAssessCountInfo().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): StudentAssessCountInfo {
    return new StudentAssessCountInfo().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): StudentAssessCountInfo {
    return new StudentAssessCountInfo().fromJsonString(jsonString, options);
  }

  static equals(a: StudentAssessCountInfo | PlainMessage<StudentAssessCountInfo> | undefined, b: StudentAssessCountInfo | PlainMessage<StudentAssessCountInfo> | undefined): boolean {
    return proto3.util.equals(StudentAssessCountInfo, a, b);
  }
}

/**
 * @generated from message geneo.lms.assessment.student.apis.StudentAssessments
 */
export class StudentAssessments extends Message<StudentAssessments> {
  /**
   * @generated from field: repeated geneo.lms.assessment.student.apis.StudentAssessmentTask active = 2;
   */
  active: StudentAssessmentTask[] = [];

  /**
   * @generated from field: repeated geneo.lms.assessment.student.apis.StudentAssessmentTask ended = 3;
   */
  ended: StudentAssessmentTask[] = [];

  constructor(data?: PartialMessage<StudentAssessments>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "geneo.lms.assessment.student.apis.StudentAssessments";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 2, name: "active", kind: "message", T: StudentAssessmentTask, repeated: true },
    { no: 3, name: "ended", kind: "message", T: StudentAssessmentTask, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): StudentAssessments {
    return new StudentAssessments().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): StudentAssessments {
    return new StudentAssessments().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): StudentAssessments {
    return new StudentAssessments().fromJsonString(jsonString, options);
  }

  static equals(a: StudentAssessments | PlainMessage<StudentAssessments> | undefined, b: StudentAssessments | PlainMessage<StudentAssessments> | undefined): boolean {
    return proto3.util.equals(StudentAssessments, a, b);
  }
}

/**
 * @generated from message geneo.lms.assessment.student.apis.StudentAssessmentTask
 */
export class StudentAssessmentTask extends Message<StudentAssessmentTask> {
  /**
   * ID of the homework
   *
   * @generated from field: int64 assessment_id = 1;
   */
  assessmentId = protoInt64.zero;

  /**
   * Title of the homework
   *
   * @generated from field: string assessment_title = 2;
   */
  assessmentTitle = "";

  /**
   * Description of the homework
   *
   * @generated from field: string description = 3;
   */
  description = "";

  /**
   * URL of the homework poster image
   *
   * @generated from field: string assessment_poster_img_url = 4;
   */
  assessmentPosterImgUrl = "";

  /**
   * Difficulty level of the homework
   *
   * @generated from field: geneo.content.db.DifficultyLevelEnum difficulty_level = 5;
   */
  difficultyLevel = DifficultyLevelEnum.DIFFICULTY_LEVEL_UNDEFINED;

  /**
   * Estimated time for which the homework is assigned
   *
   * @generated from field: float estimated_time_in_min = 6;
   */
  estimatedTimeInMin = 0;

  /**
   * ID of the teacher
   *
   * @generated from field: int64 teacher_id = 7;
   */
  teacherId = protoInt64.zero;

  /**
   * Name of the teacher who assigned the homework
   *
   * @generated from field: string teacher_name = 8;
   */
  teacherName = "";

  /**
   * URL of the teacher's profile image
   *
   * @generated from field: string teacher_profile_image_url = 9;
   */
  teacherProfileImageUrl = "";

  /**
   * Active status of the homework
   *
   * @generated from field: geneo.lms.db.TaskActiveStatusEnum assessment_active_status = 10;
   */
  assessmentActiveStatus = TaskActiveStatusEnum.TASK_ACTIVE_STATUS_UNDEFINED;

  /**
   * Attempt status of the homework for students
   *
   * @generated from field: geneo.lms.db.TaskStudentAttemptStatusEnum student_attempt_status = 11;
   */
  studentAttemptStatus = TaskStudentAttemptStatusEnum.TASK_STUDENT_STATUS_UNDEFINED;

  /**
   * ID of the course the homework belongs to
   *
   * @generated from field: optional int32 subject_id = 12;
   */
  subjectId?: number;

  /**
   * ID of the module the homework belongs to
   *
   * @generated from field: int32 module_id = 13;
   */
  moduleId = 0;

  /**
   * ID of the module
   *
   * @generated from field: geneo.content.db.Module.ModuleCategoryEnum module_category = 14;
   */
  moduleCategory = Module_ModuleCategoryEnum.MODULE_CATEGORY_UNDEFINED;

  /**
   * Subject of the homework
   *
   * @generated from field: optional string subject = 15;
   */
  subject?: string;

  /**
   * Number of questions in the homework
   *
   * @generated from field: int32 no_of_questions = 16;
   */
  noOfQuestions = 0;

  /**
   * Start date of the homework
   *
   * @generated from field: google.protobuf.Timestamp start_date = 17;
   */
  startDate?: Timestamp;

  /**
   * End date of the homework
   *
   * @generated from field: google.protobuf.Timestamp end_date = 18;
   */
  endDate?: Timestamp;

  /**
   * Score received for the homework
   *
   * @generated from field: float score_percent = 19;
   */
  scorePercent = 0;

  /**
   * @generated from field: string module_name = 20;
   */
  moduleName = "";

  /**
   * @generated from field: optional float max_marks = 21;
   */
  maxMarks?: number;

  /**
   * Only for teacher created CUSTOM hws
   *
   * @generated from field: optional geneo.lms.db.SubmissionType submission_type = 22;
   */
  submissionType?: SubmissionType;

  /**
   * @generated from field: geneo.lms.db.TaskEnum task_type = 23;
   */
  taskType = TaskEnum.TASK_UNDEFINED;

  /**
   * @generated from field: repeated geneo.lms.db.CloudUpload user_uploads = 24;
   */
  userUploads: CloudUpload[] = [];

  /**
   * @generated from field: optional geneo.lms.db.AssessmentEnum assessment_type = 25;
   */
  assessmentType?: AssessmentEnum;

  /**
   * @generated from field: geneo.lms.db.TaskMetaInfo task_meta_info = 26;
   */
  taskMetaInfo?: TaskMetaInfo;

  /**
   * @generated from field: geneo.lms.db.TaskEvaluationStatusEnum task_evaluation_status = 27;
   */
  taskEvaluationStatus = TaskEvaluationStatusEnum.TASK_EVALUATION_STATUS_UNDEFINED;

  /**
   * @generated from field: optional geneo.lms.db.ModeOfConductionEnum mode_of_conduction = 28;
   */
  modeOfConduction?: ModeOfConductionEnum;

  /**
   * @generated from field: optional geneo.lms.db.AssignmentConfigInfo assignment_config_info = 29;
   */
  assignmentConfigInfo?: AssignmentConfigInfo;

  /**
   * @generated from field: repeated int32 subject_ids = 30;
   */
  subjectIds: number[] = [];

  /**
   * @generated from field: repeated string subjects = 31;
   */
  subjects: string[] = [];

  /**
   * @generated from field: optional bool is_multi_subject_assessment_flow = 32;
   */
  isMultiSubjectAssessmentFlow?: boolean;

  constructor(data?: PartialMessage<StudentAssessmentTask>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "geneo.lms.assessment.student.apis.StudentAssessmentTask";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "assessment_id", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 2, name: "assessment_title", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "description", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "assessment_poster_img_url", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "difficulty_level", kind: "enum", T: proto3.getEnumType(DifficultyLevelEnum) },
    { no: 6, name: "estimated_time_in_min", kind: "scalar", T: 2 /* ScalarType.FLOAT */ },
    { no: 7, name: "teacher_id", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 8, name: "teacher_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 9, name: "teacher_profile_image_url", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 10, name: "assessment_active_status", kind: "enum", T: proto3.getEnumType(TaskActiveStatusEnum) },
    { no: 11, name: "student_attempt_status", kind: "enum", T: proto3.getEnumType(TaskStudentAttemptStatusEnum) },
    { no: 12, name: "subject_id", kind: "scalar", T: 5 /* ScalarType.INT32 */, opt: true },
    { no: 13, name: "module_id", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 14, name: "module_category", kind: "enum", T: proto3.getEnumType(Module_ModuleCategoryEnum) },
    { no: 15, name: "subject", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 16, name: "no_of_questions", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 17, name: "start_date", kind: "message", T: Timestamp },
    { no: 18, name: "end_date", kind: "message", T: Timestamp },
    { no: 19, name: "score_percent", kind: "scalar", T: 2 /* ScalarType.FLOAT */ },
    { no: 20, name: "module_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 21, name: "max_marks", kind: "scalar", T: 2 /* ScalarType.FLOAT */, opt: true },
    { no: 22, name: "submission_type", kind: "enum", T: proto3.getEnumType(SubmissionType), opt: true },
    { no: 23, name: "task_type", kind: "enum", T: proto3.getEnumType(TaskEnum) },
    { no: 24, name: "user_uploads", kind: "message", T: CloudUpload, repeated: true },
    { no: 25, name: "assessment_type", kind: "enum", T: proto3.getEnumType(AssessmentEnum), opt: true },
    { no: 26, name: "task_meta_info", kind: "message", T: TaskMetaInfo },
    { no: 27, name: "task_evaluation_status", kind: "enum", T: proto3.getEnumType(TaskEvaluationStatusEnum) },
    { no: 28, name: "mode_of_conduction", kind: "enum", T: proto3.getEnumType(ModeOfConductionEnum), opt: true },
    { no: 29, name: "assignment_config_info", kind: "message", T: AssignmentConfigInfo, opt: true },
    { no: 30, name: "subject_ids", kind: "scalar", T: 5 /* ScalarType.INT32 */, repeated: true },
    { no: 31, name: "subjects", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 32, name: "is_multi_subject_assessment_flow", kind: "scalar", T: 8 /* ScalarType.BOOL */, opt: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): StudentAssessmentTask {
    return new StudentAssessmentTask().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): StudentAssessmentTask {
    return new StudentAssessmentTask().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): StudentAssessmentTask {
    return new StudentAssessmentTask().fromJsonString(jsonString, options);
  }

  static equals(a: StudentAssessmentTask | PlainMessage<StudentAssessmentTask> | undefined, b: StudentAssessmentTask | PlainMessage<StudentAssessmentTask> | undefined): boolean {
    return proto3.util.equals(StudentAssessmentTask, a, b);
  }
}

/**
 * @generated from message geneo.lms.assessment.student.apis.StudentAssessmentContent
 */
export class StudentAssessmentContent extends Message<StudentAssessmentContent> {
  /**
   * ID of the homework
   *
   * @generated from field: int64 assessment_id = 1;
   */
  assessmentId = protoInt64.zero;

  /**
   * ID of the student
   *
   * @generated from field: int64 student_id = 2;
   */
  studentId = protoInt64.zero;

  /**
   * Date when the task was commenced
   *
   * @generated from field: google.protobuf.Timestamp task_start_time = 3;
   */
  taskStartTime?: Timestamp;

  /**
   * Target date for task completion
   *
   * @generated from field: google.protobuf.Timestamp task_target_date = 4;
   */
  taskTargetDate?: Timestamp;

  /**
   * Date when the task was completed
   *
   * @generated from field: google.protobuf.Timestamp task_completed_date = 5;
   */
  taskCompletedDate?: Timestamp;

  /**
   * Active status of the homework
   *
   * @generated from field: geneo.lms.db.TaskActiveStatusEnum assessment_active_status = 6;
   */
  assessmentActiveStatus = TaskActiveStatusEnum.TASK_ACTIVE_STATUS_UNDEFINED;

  /**
   * Attempt status of the homework
   *
   * @generated from field: geneo.lms.db.TaskStudentAttemptStatusEnum assessment_attempt_status = 7;
   */
  assessmentAttemptStatus = TaskStudentAttemptStatusEnum.TASK_STUDENT_STATUS_UNDEFINED;

  /**
   * Evaluation status of the homework
   *
   * @generated from field: geneo.lms.db.TaskEvaluationStatusEnum assessment_evaluation_status = 8;
   */
  assessmentEvaluationStatus = TaskEvaluationStatusEnum.TASK_EVALUATION_STATUS_UNDEFINED;

  /**
   * Metrics associated with the homework response
   *
   * @generated from field: geneo.lms.db.MetricsModel metrics = 9;
   */
  metrics?: MetricsModel;

  /**
   * List of student's responses to the homework questions
   *
   * @generated from field: repeated geneo.lms.db.StudentAssessmentResponse responses = 10;
   */
  responses: StudentAssessmentResponse[] = [];

  /**
   * Creation timestamp
   *
   * @generated from field: google.protobuf.Timestamp created_on = 11;
   */
  createdOn?: Timestamp;

  /**
   * Last modification timestamp
   *
   * @generated from field: optional google.protobuf.Timestamp modified_on = 12;
   */
  modifiedOn?: Timestamp;

  /**
   * @generated from field: repeated geneo.lms.db.CloudUpload user_uploads = 13;
   */
  userUploads: CloudUpload[] = [];

  /**
   * have to include assignment confige
   *
   * @generated from field: int32 total_time = 14;
   */
  totalTime = 0;

  constructor(data?: PartialMessage<StudentAssessmentContent>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "geneo.lms.assessment.student.apis.StudentAssessmentContent";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "assessment_id", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 2, name: "student_id", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 3, name: "task_start_time", kind: "message", T: Timestamp },
    { no: 4, name: "task_target_date", kind: "message", T: Timestamp },
    { no: 5, name: "task_completed_date", kind: "message", T: Timestamp },
    { no: 6, name: "assessment_active_status", kind: "enum", T: proto3.getEnumType(TaskActiveStatusEnum) },
    { no: 7, name: "assessment_attempt_status", kind: "enum", T: proto3.getEnumType(TaskStudentAttemptStatusEnum) },
    { no: 8, name: "assessment_evaluation_status", kind: "enum", T: proto3.getEnumType(TaskEvaluationStatusEnum) },
    { no: 9, name: "metrics", kind: "message", T: MetricsModel },
    { no: 10, name: "responses", kind: "message", T: StudentAssessmentResponse, repeated: true },
    { no: 11, name: "created_on", kind: "message", T: Timestamp },
    { no: 12, name: "modified_on", kind: "message", T: Timestamp, opt: true },
    { no: 13, name: "user_uploads", kind: "message", T: CloudUpload, repeated: true },
    { no: 14, name: "total_time", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): StudentAssessmentContent {
    return new StudentAssessmentContent().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): StudentAssessmentContent {
    return new StudentAssessmentContent().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): StudentAssessmentContent {
    return new StudentAssessmentContent().fromJsonString(jsonString, options);
  }

  static equals(a: StudentAssessmentContent | PlainMessage<StudentAssessmentContent> | undefined, b: StudentAssessmentContent | PlainMessage<StudentAssessmentContent> | undefined): boolean {
    return proto3.util.equals(StudentAssessmentContent, a, b);
  }
}

/**
 * @generated from message geneo.lms.assessment.student.apis.CreateStudentAssessmentSessionRequest
 */
export class CreateStudentAssessmentSessionRequest extends Message<CreateStudentAssessmentSessionRequest> {
  /**
   * ID of the student associated with the lesson session.
   *
   * @generated from field: int64 student_id = 1;
   */
  studentId = protoInt64.zero;

  /**
   * Section of the student.
   *
   * @generated from field: int64 assessment_id = 2;
   */
  assessmentId = protoInt64.zero;

  /**
   * Status of the lesson session (e.g., in progress, completed, etc.).
   *
   * @generated from field: geneo.lms.db.TaskStudentAttemptStatusEnum session_status = 3;
   */
  sessionStatus = TaskStudentAttemptStatusEnum.TASK_STUDENT_STATUS_UNDEFINED;

  /**
   * Mode of the lesson session (e.g., online, offline, etc.).
   *
   * @generated from field: geneo.lms.db.AssessmentSessionModeEnum session_mode = 4;
   */
  sessionMode = AssessmentSessionModeEnum.ASSESSMENT_SESSION_MODE_UNDEFINED;

  /**
   * Client device local time, used to detect client/server clock mismatch.
   *
   * @generated from field: optional google.protobuf.Timestamp client_timestamp = 5;
   */
  clientTimestamp?: Timestamp;

  constructor(data?: PartialMessage<CreateStudentAssessmentSessionRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "geneo.lms.assessment.student.apis.CreateStudentAssessmentSessionRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "student_id", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 2, name: "assessment_id", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 3, name: "session_status", kind: "enum", T: proto3.getEnumType(TaskStudentAttemptStatusEnum) },
    { no: 4, name: "session_mode", kind: "enum", T: proto3.getEnumType(AssessmentSessionModeEnum) },
    { no: 5, name: "client_timestamp", kind: "message", T: Timestamp, opt: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): CreateStudentAssessmentSessionRequest {
    return new CreateStudentAssessmentSessionRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): CreateStudentAssessmentSessionRequest {
    return new CreateStudentAssessmentSessionRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): CreateStudentAssessmentSessionRequest {
    return new CreateStudentAssessmentSessionRequest().fromJsonString(jsonString, options);
  }

  static equals(a: CreateStudentAssessmentSessionRequest | PlainMessage<CreateStudentAssessmentSessionRequest> | undefined, b: CreateStudentAssessmentSessionRequest | PlainMessage<CreateStudentAssessmentSessionRequest> | undefined): boolean {
    return proto3.util.equals(CreateStudentAssessmentSessionRequest, a, b);
  }
}

/**
 * @generated from message geneo.lms.assessment.student.apis.CreateStudentAssessmentSessionResponse
 */
export class CreateStudentAssessmentSessionResponse extends Message<CreateStudentAssessmentSessionResponse> {
  /**
   * @generated from field: int32 status = 1;
   */
  status = 0;

  /**
   * @generated from field: string code = 2;
   */
  code = "";

  /**
   * @generated from field: string message = 3;
   */
  message = "";

  /**
   * @generated from field: int64 session_id = 4;
   */
  sessionId = protoInt64.zero;

  /**
   * @generated from field: optional int32 attempt_number = 5;
   */
  attemptNumber?: number;

  constructor(data?: PartialMessage<CreateStudentAssessmentSessionResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "geneo.lms.assessment.student.apis.CreateStudentAssessmentSessionResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "status", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 2, name: "code", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "message", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "session_id", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 5, name: "attempt_number", kind: "scalar", T: 5 /* ScalarType.INT32 */, opt: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): CreateStudentAssessmentSessionResponse {
    return new CreateStudentAssessmentSessionResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): CreateStudentAssessmentSessionResponse {
    return new CreateStudentAssessmentSessionResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): CreateStudentAssessmentSessionResponse {
    return new CreateStudentAssessmentSessionResponse().fromJsonString(jsonString, options);
  }

  static equals(a: CreateStudentAssessmentSessionResponse | PlainMessage<CreateStudentAssessmentSessionResponse> | undefined, b: CreateStudentAssessmentSessionResponse | PlainMessage<CreateStudentAssessmentSessionResponse> | undefined): boolean {
    return proto3.util.equals(CreateStudentAssessmentSessionResponse, a, b);
  }
}

/**
 * @generated from message geneo.lms.assessment.student.apis.SubmitAssessmentResponseSubmitRequest
 */
export class SubmitAssessmentResponseSubmitRequest extends Message<SubmitAssessmentResponseSubmitRequest> {
  /**
   * @generated from field: int64 student_id = 1;
   */
  studentId = protoInt64.zero;

  /**
   * @generated from field: int64 assessment_id = 2;
   */
  assessmentId = protoInt64.zero;

  /**
   * @generated from field: geneo.lms.db.TaskStudentAttemptStatusEnum assessment_attempt_status = 3;
   */
  assessmentAttemptStatus = TaskStudentAttemptStatusEnum.TASK_STUDENT_STATUS_UNDEFINED;

  /**
   * @generated from field: repeated geneo.lms.db.StudentAssessmentResponse responses = 4;
   */
  responses: StudentAssessmentResponse[] = [];

  /**
   * @generated from field: google.protobuf.Timestamp timestamp = 5;
   */
  timestamp?: Timestamp;

  /**
   * @generated from field: int64 session_id = 6;
   */
  sessionId = protoInt64.zero;

  /**
   * @generated from field: repeated geneo.lms.hw.student.apis.UploadFileResponse user_uploads = 7;
   */
  userUploads: UploadFileResponse[] = [];

  /**
   * @generated from field: geneo.lms.db.TaskEnum task_type = 8;
   */
  taskType = TaskEnum.TASK_UNDEFINED;

  /**
   * @generated from field: optional float attempt_spent_time_in_secs = 9;
   */
  attemptSpentTimeInSecs?: number;

  constructor(data?: PartialMessage<SubmitAssessmentResponseSubmitRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "geneo.lms.assessment.student.apis.SubmitAssessmentResponseSubmitRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "student_id", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 2, name: "assessment_id", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 3, name: "assessment_attempt_status", kind: "enum", T: proto3.getEnumType(TaskStudentAttemptStatusEnum) },
    { no: 4, name: "responses", kind: "message", T: StudentAssessmentResponse, repeated: true },
    { no: 5, name: "timestamp", kind: "message", T: Timestamp },
    { no: 6, name: "session_id", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 7, name: "user_uploads", kind: "message", T: UploadFileResponse, repeated: true },
    { no: 8, name: "task_type", kind: "enum", T: proto3.getEnumType(TaskEnum) },
    { no: 9, name: "attempt_spent_time_in_secs", kind: "scalar", T: 2 /* ScalarType.FLOAT */, opt: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): SubmitAssessmentResponseSubmitRequest {
    return new SubmitAssessmentResponseSubmitRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): SubmitAssessmentResponseSubmitRequest {
    return new SubmitAssessmentResponseSubmitRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): SubmitAssessmentResponseSubmitRequest {
    return new SubmitAssessmentResponseSubmitRequest().fromJsonString(jsonString, options);
  }

  static equals(a: SubmitAssessmentResponseSubmitRequest | PlainMessage<SubmitAssessmentResponseSubmitRequest> | undefined, b: SubmitAssessmentResponseSubmitRequest | PlainMessage<SubmitAssessmentResponseSubmitRequest> | undefined): boolean {
    return proto3.util.equals(SubmitAssessmentResponseSubmitRequest, a, b);
  }
}

/**
 * @generated from message geneo.lms.assessment.student.apis.SubmitAssessmentResponseSubmitResponse
 */
export class SubmitAssessmentResponseSubmitResponse extends Message<SubmitAssessmentResponseSubmitResponse> {
  /**
   * @generated from field: int32 status = 1;
   */
  status = 0;

  /**
   * @generated from field: string code = 2;
   */
  code = "";

  /**
   * @generated from field: string message = 3;
   */
  message = "";

  /**
   * @generated from field: optional geneo.lms.assessment.student.apis.StudentAssessAttemptResult attempt_result = 4;
   */
  attemptResult?: StudentAssessAttemptResult;

  constructor(data?: PartialMessage<SubmitAssessmentResponseSubmitResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "geneo.lms.assessment.student.apis.SubmitAssessmentResponseSubmitResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "status", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 2, name: "code", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "message", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "attempt_result", kind: "message", T: StudentAssessAttemptResult, opt: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): SubmitAssessmentResponseSubmitResponse {
    return new SubmitAssessmentResponseSubmitResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): SubmitAssessmentResponseSubmitResponse {
    return new SubmitAssessmentResponseSubmitResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): SubmitAssessmentResponseSubmitResponse {
    return new SubmitAssessmentResponseSubmitResponse().fromJsonString(jsonString, options);
  }

  static equals(a: SubmitAssessmentResponseSubmitResponse | PlainMessage<SubmitAssessmentResponseSubmitResponse> | undefined, b: SubmitAssessmentResponseSubmitResponse | PlainMessage<SubmitAssessmentResponseSubmitResponse> | undefined): boolean {
    return proto3.util.equals(SubmitAssessmentResponseSubmitResponse, a, b);
  }
}

/**
 * @generated from message geneo.lms.assessment.student.apis.SubmitStudentAssessmentResponseSubmitRequest
 */
export class SubmitStudentAssessmentResponseSubmitRequest extends Message<SubmitStudentAssessmentResponseSubmitRequest> {
  /**
   * @generated from field: int64 student_id = 1;
   */
  studentId = protoInt64.zero;

  /**
   * @generated from field: int64 assessment_id = 2;
   */
  assessmentId = protoInt64.zero;

  /**
   * @generated from field: geneo.lms.db.TaskStudentAttemptStatusEnum assessment_attempt_status = 3;
   */
  assessmentAttemptStatus = TaskStudentAttemptStatusEnum.TASK_STUDENT_STATUS_UNDEFINED;

  /**
   * @generated from field: repeated geneo.lms.db.StudentAssessmentResponse responses = 4;
   */
  responses: StudentAssessmentResponse[] = [];

  /**
   * @generated from field: google.protobuf.Timestamp timestamp = 5;
   */
  timestamp?: Timestamp;

  /**
   * @generated from field: int64 session_id = 6;
   */
  sessionId = protoInt64.zero;

  /**
   * @generated from field: repeated geneo.lms.hw.student.apis.UploadFileResponse user_uploads = 7;
   */
  userUploads: UploadFileResponse[] = [];

  /**
   * @generated from field: geneo.lms.db.TaskEnum task_type = 8;
   */
  taskType = TaskEnum.TASK_UNDEFINED;

  /**
   * @generated from field: optional float attempt_spent_time_in_secs = 9;
   */
  attemptSpentTimeInSecs?: number;

  constructor(data?: PartialMessage<SubmitStudentAssessmentResponseSubmitRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "geneo.lms.assessment.student.apis.SubmitStudentAssessmentResponseSubmitRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "student_id", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 2, name: "assessment_id", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 3, name: "assessment_attempt_status", kind: "enum", T: proto3.getEnumType(TaskStudentAttemptStatusEnum) },
    { no: 4, name: "responses", kind: "message", T: StudentAssessmentResponse, repeated: true },
    { no: 5, name: "timestamp", kind: "message", T: Timestamp },
    { no: 6, name: "session_id", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 7, name: "user_uploads", kind: "message", T: UploadFileResponse, repeated: true },
    { no: 8, name: "task_type", kind: "enum", T: proto3.getEnumType(TaskEnum) },
    { no: 9, name: "attempt_spent_time_in_secs", kind: "scalar", T: 2 /* ScalarType.FLOAT */, opt: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): SubmitStudentAssessmentResponseSubmitRequest {
    return new SubmitStudentAssessmentResponseSubmitRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): SubmitStudentAssessmentResponseSubmitRequest {
    return new SubmitStudentAssessmentResponseSubmitRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): SubmitStudentAssessmentResponseSubmitRequest {
    return new SubmitStudentAssessmentResponseSubmitRequest().fromJsonString(jsonString, options);
  }

  static equals(a: SubmitStudentAssessmentResponseSubmitRequest | PlainMessage<SubmitStudentAssessmentResponseSubmitRequest> | undefined, b: SubmitStudentAssessmentResponseSubmitRequest | PlainMessage<SubmitStudentAssessmentResponseSubmitRequest> | undefined): boolean {
    return proto3.util.equals(SubmitStudentAssessmentResponseSubmitRequest, a, b);
  }
}

/**
 * @generated from message geneo.lms.assessment.student.apis.SubmitStudentAssessmentResponseSubmitResponse
 */
export class SubmitStudentAssessmentResponseSubmitResponse extends Message<SubmitStudentAssessmentResponseSubmitResponse> {
  /**
   * @generated from field: int32 status = 1;
   */
  status = 0;

  /**
   * @generated from field: string code = 2;
   */
  code = "";

  /**
   * @generated from field: string message = 3;
   */
  message = "";

  /**
   * @generated from field: optional geneo.lms.assessment.student.apis.StudentAssessAttemptResult attempt_result = 4;
   */
  attemptResult?: StudentAssessAttemptResult;

  constructor(data?: PartialMessage<SubmitStudentAssessmentResponseSubmitResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "geneo.lms.assessment.student.apis.SubmitStudentAssessmentResponseSubmitResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "status", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 2, name: "code", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "message", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "attempt_result", kind: "message", T: StudentAssessAttemptResult, opt: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): SubmitStudentAssessmentResponseSubmitResponse {
    return new SubmitStudentAssessmentResponseSubmitResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): SubmitStudentAssessmentResponseSubmitResponse {
    return new SubmitStudentAssessmentResponseSubmitResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): SubmitStudentAssessmentResponseSubmitResponse {
    return new SubmitStudentAssessmentResponseSubmitResponse().fromJsonString(jsonString, options);
  }

  static equals(a: SubmitStudentAssessmentResponseSubmitResponse | PlainMessage<SubmitStudentAssessmentResponseSubmitResponse> | undefined, b: SubmitStudentAssessmentResponseSubmitResponse | PlainMessage<SubmitStudentAssessmentResponseSubmitResponse> | undefined): boolean {
    return proto3.util.equals(SubmitStudentAssessmentResponseSubmitResponse, a, b);
  }
}

/**
 * @generated from message geneo.lms.assessment.student.apis.StudentAssessAttemptResult
 */
export class StudentAssessAttemptResult extends Message<StudentAssessAttemptResult> {
  /**
   * @generated from field: float response_score = 1;
   */
  responseScore = 0;

  /**
   * @generated from field: float max_score = 2;
   */
  maxScore = 0;

  constructor(data?: PartialMessage<StudentAssessAttemptResult>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "geneo.lms.assessment.student.apis.StudentAssessAttemptResult";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "response_score", kind: "scalar", T: 2 /* ScalarType.FLOAT */ },
    { no: 2, name: "max_score", kind: "scalar", T: 2 /* ScalarType.FLOAT */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): StudentAssessAttemptResult {
    return new StudentAssessAttemptResult().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): StudentAssessAttemptResult {
    return new StudentAssessAttemptResult().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): StudentAssessAttemptResult {
    return new StudentAssessAttemptResult().fromJsonString(jsonString, options);
  }

  static equals(a: StudentAssessAttemptResult | PlainMessage<StudentAssessAttemptResult> | undefined, b: StudentAssessAttemptResult | PlainMessage<StudentAssessAttemptResult> | undefined): boolean {
    return proto3.util.equals(StudentAssessAttemptResult, a, b);
  }
}

/**
 * @generated from message geneo.lms.assessment.student.apis.FetchStudentAssessmentResponseFetchRequest
 */
export class FetchStudentAssessmentResponseFetchRequest extends Message<FetchStudentAssessmentResponseFetchRequest> {
  /**
   * @generated from field: int64 student_id = 1;
   */
  studentId = protoInt64.zero;

  /**
   * @generated from field: int64 assessment_id = 2;
   */
  assessmentId = protoInt64.zero;

  /**
   * @generated from field: optional int32 attempt_number = 3;
   */
  attemptNumber?: number;

  /**
   * @generated from field: optional geneo.lms.db.AttemptTypeEnum attempt_type = 4;
   */
  attemptType?: AttemptTypeEnum;

  constructor(data?: PartialMessage<FetchStudentAssessmentResponseFetchRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "geneo.lms.assessment.student.apis.FetchStudentAssessmentResponseFetchRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "student_id", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 2, name: "assessment_id", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 3, name: "attempt_number", kind: "scalar", T: 5 /* ScalarType.INT32 */, opt: true },
    { no: 4, name: "attempt_type", kind: "enum", T: proto3.getEnumType(AttemptTypeEnum), opt: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): FetchStudentAssessmentResponseFetchRequest {
    return new FetchStudentAssessmentResponseFetchRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): FetchStudentAssessmentResponseFetchRequest {
    return new FetchStudentAssessmentResponseFetchRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): FetchStudentAssessmentResponseFetchRequest {
    return new FetchStudentAssessmentResponseFetchRequest().fromJsonString(jsonString, options);
  }

  static equals(a: FetchStudentAssessmentResponseFetchRequest | PlainMessage<FetchStudentAssessmentResponseFetchRequest> | undefined, b: FetchStudentAssessmentResponseFetchRequest | PlainMessage<FetchStudentAssessmentResponseFetchRequest> | undefined): boolean {
    return proto3.util.equals(FetchStudentAssessmentResponseFetchRequest, a, b);
  }
}

/**
 * @generated from message geneo.lms.assessment.student.apis.FetchStudentAssessmentResponseFetchResponse
 */
export class FetchStudentAssessmentResponseFetchResponse extends Message<FetchStudentAssessmentResponseFetchResponse> {
  /**
   * @generated from field: int32 status = 1;
   */
  status = 0;

  /**
   * @generated from field: string code = 2;
   */
  code = "";

  /**
   * @generated from field: string message = 3;
   */
  message = "";

  /**
   * @generated from field: geneo.lms.assessment.student.apis.AssessmentStudentResponse data = 4;
   */
  data?: AssessmentStudentResponse;

  constructor(data?: PartialMessage<FetchStudentAssessmentResponseFetchResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "geneo.lms.assessment.student.apis.FetchStudentAssessmentResponseFetchResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "status", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 2, name: "code", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "message", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "data", kind: "message", T: AssessmentStudentResponse },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): FetchStudentAssessmentResponseFetchResponse {
    return new FetchStudentAssessmentResponseFetchResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): FetchStudentAssessmentResponseFetchResponse {
    return new FetchStudentAssessmentResponseFetchResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): FetchStudentAssessmentResponseFetchResponse {
    return new FetchStudentAssessmentResponseFetchResponse().fromJsonString(jsonString, options);
  }

  static equals(a: FetchStudentAssessmentResponseFetchResponse | PlainMessage<FetchStudentAssessmentResponseFetchResponse> | undefined, b: FetchStudentAssessmentResponseFetchResponse | PlainMessage<FetchStudentAssessmentResponseFetchResponse> | undefined): boolean {
    return proto3.util.equals(FetchStudentAssessmentResponseFetchResponse, a, b);
  }
}

/**
 * @generated from message geneo.lms.assessment.student.apis.AssessmentStudentResponse
 */
export class AssessmentStudentResponse extends Message<AssessmentStudentResponse> {
  /**
   * ID of the homework
   *
   * @generated from field: int64 assessment_id = 1;
   */
  assessmentId = protoInt64.zero;

  /**
   * ID of the student
   *
   * @generated from field: int64 student_id = 2;
   */
  studentId = protoInt64.zero;

  /**
   * Date when the task was commenced
   *
   * @generated from field: google.protobuf.Timestamp task_commence_date = 3;
   */
  taskCommenceDate?: Timestamp;

  /**
   * Target date for task completion
   *
   * @generated from field: google.protobuf.Timestamp task_target_date = 4;
   */
  taskTargetDate?: Timestamp;

  /**
   * Date when the task was completed
   *
   * @generated from field: google.protobuf.Timestamp task_completed_date = 5;
   */
  taskCompletedDate?: Timestamp;

  /**
   * Active status of the assessment
   *
   * @generated from field: geneo.lms.db.TaskActiveStatusEnum assessment_active_status = 6;
   */
  assessmentActiveStatus = TaskActiveStatusEnum.TASK_ACTIVE_STATUS_UNDEFINED;

  /**
   * Attempt status of the assessment
   *
   * @generated from field: geneo.lms.db.TaskStudentAttemptStatusEnum assessment_attempt_status = 7;
   */
  assessmentAttemptStatus = TaskStudentAttemptStatusEnum.TASK_STUDENT_STATUS_UNDEFINED;

  /**
   * Evaluation status of the homework
   *
   * @generated from field: geneo.lms.db.TaskEvaluationStatusEnum assessment_evaluation_status = 8;
   */
  assessmentEvaluationStatus = TaskEvaluationStatusEnum.TASK_EVALUATION_STATUS_UNDEFINED;

  /**
   * @generated from field: optional geneo.lms.db.AssessmentEnum assessment_type = 9;
   */
  assessmentType?: AssessmentEnum;

  /**
   * Metrics associated with the homework response
   *
   * @generated from field: geneo.lms.db.MetricsModel metrics = 10;
   */
  metrics?: MetricsModel;

  /**
   * List of student's responses to the homework questions
   *
   * @generated from field: repeated geneo.lms.db.StudentAssessmentResponse responses = 11;
   */
  responses: StudentAssessmentResponse[] = [];

  /**
   * Creation timestamp
   *
   * @generated from field: google.protobuf.Timestamp created_on = 12;
   */
  createdOn?: Timestamp;

  /**
   * Last modification timestamp
   *
   * @generated from field: optional google.protobuf.Timestamp modified_on = 13;
   */
  modifiedOn?: Timestamp;

  /**
   * @generated from field: repeated geneo.lms.db.CloudUpload user_uploads = 14;
   */
  userUploads: CloudUpload[] = [];

  /**
   * @generated from field: optional float attempt_spent_time_in_secs = 15;
   */
  attemptSpentTimeInSecs?: number;

  /**
   * @generated from field: repeated geneo.lms.db.AttemptStats attempt_info = 16;
   */
  attemptInfo: AttemptStats[] = [];

  /**
   * @generated from field: optional geneo.lms.db.TaskTeacherReview teacher_review = 17;
   */
  teacherReview?: TaskTeacherReview;

  /**
   * @generated from field: repeated string completed_resource_ids = 18;
   */
  completedResourceIds: string[] = [];

  /**
   * @generated from field: repeated geneo.lms.assessment.student.apis.AssignedResourceInfo assigned_resources = 19;
   */
  assignedResources: AssignedResourceInfo[] = [];

  constructor(data?: PartialMessage<AssessmentStudentResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "geneo.lms.assessment.student.apis.AssessmentStudentResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "assessment_id", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 2, name: "student_id", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 3, name: "task_commence_date", kind: "message", T: Timestamp },
    { no: 4, name: "task_target_date", kind: "message", T: Timestamp },
    { no: 5, name: "task_completed_date", kind: "message", T: Timestamp },
    { no: 6, name: "assessment_active_status", kind: "enum", T: proto3.getEnumType(TaskActiveStatusEnum) },
    { no: 7, name: "assessment_attempt_status", kind: "enum", T: proto3.getEnumType(TaskStudentAttemptStatusEnum) },
    { no: 8, name: "assessment_evaluation_status", kind: "enum", T: proto3.getEnumType(TaskEvaluationStatusEnum) },
    { no: 9, name: "assessment_type", kind: "enum", T: proto3.getEnumType(AssessmentEnum), opt: true },
    { no: 10, name: "metrics", kind: "message", T: MetricsModel },
    { no: 11, name: "responses", kind: "message", T: StudentAssessmentResponse, repeated: true },
    { no: 12, name: "created_on", kind: "message", T: Timestamp },
    { no: 13, name: "modified_on", kind: "message", T: Timestamp, opt: true },
    { no: 14, name: "user_uploads", kind: "message", T: CloudUpload, repeated: true },
    { no: 15, name: "attempt_spent_time_in_secs", kind: "scalar", T: 2 /* ScalarType.FLOAT */, opt: true },
    { no: 16, name: "attempt_info", kind: "message", T: AttemptStats, repeated: true },
    { no: 17, name: "teacher_review", kind: "message", T: TaskTeacherReview, opt: true },
    { no: 18, name: "completed_resource_ids", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 19, name: "assigned_resources", kind: "message", T: AssignedResourceInfo, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): AssessmentStudentResponse {
    return new AssessmentStudentResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): AssessmentStudentResponse {
    return new AssessmentStudentResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): AssessmentStudentResponse {
    return new AssessmentStudentResponse().fromJsonString(jsonString, options);
  }

  static equals(a: AssessmentStudentResponse | PlainMessage<AssessmentStudentResponse> | undefined, b: AssessmentStudentResponse | PlainMessage<AssessmentStudentResponse> | undefined): boolean {
    return proto3.util.equals(AssessmentStudentResponse, a, b);
  }
}

/**
 * @generated from message geneo.lms.assessment.student.apis.AssignedResourceInfo
 */
export class AssignedResourceInfo extends Message<AssignedResourceInfo> {
  /**
   * @generated from field: string resource_id = 1;
   */
  resourceId = "";

  /**
   * @generated from field: string title = 2;
   */
  title = "";

  /**
   * @generated from field: string poster_image_url = 3;
   */
  posterImageUrl = "";

  /**
   * @generated from field: geneo.content.db.Resource.ResourceEnum resource_type = 4;
   */
  resourceType = Resource_ResourceEnum.RESOURCE_TYPE_UNDEFINED;

  /**
   * @generated from field: int32 estimated_time_in_min = 5;
   */
  estimatedTimeInMin = 0;

  /**
   * @generated from field: geneo.content.db.ResourceCategoryEnum resource_category_type = 6;
   */
  resourceCategoryType = ResourceCategoryEnum.RESOURCE_CATEGORY_UNDEFINED;

  constructor(data?: PartialMessage<AssignedResourceInfo>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "geneo.lms.assessment.student.apis.AssignedResourceInfo";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "resource_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "title", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "poster_image_url", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "resource_type", kind: "enum", T: proto3.getEnumType(Resource_ResourceEnum) },
    { no: 5, name: "estimated_time_in_min", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 6, name: "resource_category_type", kind: "enum", T: proto3.getEnumType(ResourceCategoryEnum) },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): AssignedResourceInfo {
    return new AssignedResourceInfo().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): AssignedResourceInfo {
    return new AssignedResourceInfo().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): AssignedResourceInfo {
    return new AssignedResourceInfo().fromJsonString(jsonString, options);
  }

  static equals(a: AssignedResourceInfo | PlainMessage<AssignedResourceInfo> | undefined, b: AssignedResourceInfo | PlainMessage<AssignedResourceInfo> | undefined): boolean {
    return proto3.util.equals(AssignedResourceInfo, a, b);
  }
}

/**
 * @generated from message geneo.lms.assessment.student.apis.FetchStudentAssessmentReportsRequest
 */
export class FetchStudentAssessmentReportsRequest extends Message<FetchStudentAssessmentReportsRequest> {
  /**
   * @generated from field: int64 student_id = 1;
   */
  studentId = protoInt64.zero;

  /**
   * @generated from field: optional int32 page_number = 2;
   */
  pageNumber?: number;

  /**
   * @generated from field: optional int32 subject_id = 3;
   */
  subjectId?: number;

  /**
   * @generated from field: optional geneo.lms.db.AssessmentEnum assessment_type = 4;
   */
  assessmentType?: AssessmentEnum;

  /**
   * @generated from field: optional string search_key = 5;
   */
  searchKey?: string;

  constructor(data?: PartialMessage<FetchStudentAssessmentReportsRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "geneo.lms.assessment.student.apis.FetchStudentAssessmentReportsRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "student_id", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 2, name: "page_number", kind: "scalar", T: 5 /* ScalarType.INT32 */, opt: true },
    { no: 3, name: "subject_id", kind: "scalar", T: 5 /* ScalarType.INT32 */, opt: true },
    { no: 4, name: "assessment_type", kind: "enum", T: proto3.getEnumType(AssessmentEnum), opt: true },
    { no: 5, name: "search_key", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): FetchStudentAssessmentReportsRequest {
    return new FetchStudentAssessmentReportsRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): FetchStudentAssessmentReportsRequest {
    return new FetchStudentAssessmentReportsRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): FetchStudentAssessmentReportsRequest {
    return new FetchStudentAssessmentReportsRequest().fromJsonString(jsonString, options);
  }

  static equals(a: FetchStudentAssessmentReportsRequest | PlainMessage<FetchStudentAssessmentReportsRequest> | undefined, b: FetchStudentAssessmentReportsRequest | PlainMessage<FetchStudentAssessmentReportsRequest> | undefined): boolean {
    return proto3.util.equals(FetchStudentAssessmentReportsRequest, a, b);
  }
}

/**
 * @generated from message geneo.lms.assessment.student.apis.FetchStudentAssessmentReportsResponse
 */
export class FetchStudentAssessmentReportsResponse extends Message<FetchStudentAssessmentReportsResponse> {
  /**
   * Response status
   *
   * @generated from field: int32 status = 1;
   */
  status = 0;

  /**
   * Response code
   *
   * @generated from field: string code = 2;
   */
  code = "";

  /**
   * Response message
   *
   * @generated from field: string message = 3;
   */
  message = "";

  /**
   * @generated from field: geneo.lms.assessment.student.apis.StudentAssessmentReportData data = 4;
   */
  data?: StudentAssessmentReportData;

  constructor(data?: PartialMessage<FetchStudentAssessmentReportsResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "geneo.lms.assessment.student.apis.FetchStudentAssessmentReportsResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "status", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 2, name: "code", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "message", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "data", kind: "message", T: StudentAssessmentReportData },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): FetchStudentAssessmentReportsResponse {
    return new FetchStudentAssessmentReportsResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): FetchStudentAssessmentReportsResponse {
    return new FetchStudentAssessmentReportsResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): FetchStudentAssessmentReportsResponse {
    return new FetchStudentAssessmentReportsResponse().fromJsonString(jsonString, options);
  }

  static equals(a: FetchStudentAssessmentReportsResponse | PlainMessage<FetchStudentAssessmentReportsResponse> | undefined, b: FetchStudentAssessmentReportsResponse | PlainMessage<FetchStudentAssessmentReportsResponse> | undefined): boolean {
    return proto3.util.equals(FetchStudentAssessmentReportsResponse, a, b);
  }
}

/**
 * @generated from message geneo.lms.assessment.student.apis.StudentAssessmentReportData
 */
export class StudentAssessmentReportData extends Message<StudentAssessmentReportData> {
  /**
   * @generated from field: int64 student_id = 1;
   */
  studentId = protoInt64.zero;

  /**
   * @generated from field: repeated geneo.lms.assessment.student.apis.StudentReportCenterData student_reports = 2;
   */
  studentReports: StudentReportCenterData[] = [];

  /**
   * @generated from field: optional geneo.lms.assessment.student.apis.StudentReportCountInfo student_reports_info = 3;
   */
  studentReportsInfo?: StudentReportCountInfo;

  constructor(data?: PartialMessage<StudentAssessmentReportData>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "geneo.lms.assessment.student.apis.StudentAssessmentReportData";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "student_id", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 2, name: "student_reports", kind: "message", T: StudentReportCenterData, repeated: true },
    { no: 3, name: "student_reports_info", kind: "message", T: StudentReportCountInfo, opt: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): StudentAssessmentReportData {
    return new StudentAssessmentReportData().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): StudentAssessmentReportData {
    return new StudentAssessmentReportData().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): StudentAssessmentReportData {
    return new StudentAssessmentReportData().fromJsonString(jsonString, options);
  }

  static equals(a: StudentAssessmentReportData | PlainMessage<StudentAssessmentReportData> | undefined, b: StudentAssessmentReportData | PlainMessage<StudentAssessmentReportData> | undefined): boolean {
    return proto3.util.equals(StudentAssessmentReportData, a, b);
  }
}

/**
 * @generated from message geneo.lms.assessment.student.apis.StudentReportCenterData
 */
export class StudentReportCenterData extends Message<StudentReportCenterData> {
  /**
   * @generated from field: optional string assessment_name = 1;
   */
  assessmentName?: string;

  /**
   * @generated from field: optional string assessment_id = 2;
   */
  assessmentId?: string;

  /**
   * @generated from field: optional geneo.lms.db.AssessmentEnum assessment_type = 3;
   */
  assessmentType?: AssessmentEnum;

  /**
   * @generated from field: optional google.protobuf.Timestamp completion_date = 4;
   */
  completionDate?: Timestamp;

  /**
   * @generated from field: optional string subject = 5;
   */
  subject?: string;

  /**
   * @generated from field: optional string report_url = 6;
   */
  reportUrl?: string;

  /**
   * @generated from field: optional int32 report_id = 7;
   */
  reportId?: number;

  constructor(data?: PartialMessage<StudentReportCenterData>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "geneo.lms.assessment.student.apis.StudentReportCenterData";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "assessment_name", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 2, name: "assessment_id", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 3, name: "assessment_type", kind: "enum", T: proto3.getEnumType(AssessmentEnum), opt: true },
    { no: 4, name: "completion_date", kind: "message", T: Timestamp, opt: true },
    { no: 5, name: "subject", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 6, name: "report_url", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 7, name: "report_id", kind: "scalar", T: 5 /* ScalarType.INT32 */, opt: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): StudentReportCenterData {
    return new StudentReportCenterData().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): StudentReportCenterData {
    return new StudentReportCenterData().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): StudentReportCenterData {
    return new StudentReportCenterData().fromJsonString(jsonString, options);
  }

  static equals(a: StudentReportCenterData | PlainMessage<StudentReportCenterData> | undefined, b: StudentReportCenterData | PlainMessage<StudentReportCenterData> | undefined): boolean {
    return proto3.util.equals(StudentReportCenterData, a, b);
  }
}

/**
 * @generated from message geneo.lms.assessment.student.apis.StudentReportCountInfo
 */
export class StudentReportCountInfo extends Message<StudentReportCountInfo> {
  /**
   * @generated from field: int32 report_count = 1;
   */
  reportCount = 0;

  /**
   * @generated from field: int32 count_in_pagination = 2;
   */
  countInPagination = 0;

  constructor(data?: PartialMessage<StudentReportCountInfo>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "geneo.lms.assessment.student.apis.StudentReportCountInfo";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "report_count", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 2, name: "count_in_pagination", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): StudentReportCountInfo {
    return new StudentReportCountInfo().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): StudentReportCountInfo {
    return new StudentReportCountInfo().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): StudentReportCountInfo {
    return new StudentReportCountInfo().fromJsonString(jsonString, options);
  }

  static equals(a: StudentReportCountInfo | PlainMessage<StudentReportCountInfo> | undefined, b: StudentReportCountInfo | PlainMessage<StudentReportCountInfo> | undefined): boolean {
    return proto3.util.equals(StudentReportCountInfo, a, b);
  }
}

/**
 * @generated from message geneo.lms.assessment.student.apis.CreateProctoringLogsRequest
 */
export class CreateProctoringLogsRequest extends Message<CreateProctoringLogsRequest> {
  /**
   * @generated from field: int64 student_id = 1;
   */
  studentId = protoInt64.zero;

  /**
   * @generated from field: int64 assessment_id = 2;
   */
  assessmentId = protoInt64.zero;

  /**
   * @generated from field: int64 homework_session_id = 3;
   */
  homeworkSessionId = protoInt64.zero;

  /**
   * @generated from field: string question_id = 5;
   */
  questionId = "";

  /**
   * @generated from field: repeated google.protobuf.Timestamp full_screen_exits = 6;
   */
  fullScreenExits: Timestamp[] = [];

  /**
   * @generated from field: repeated google.protobuf.Timestamp tab_switches = 7;
   */
  tabSwitches: Timestamp[] = [];

  /**
   * @generated from field: repeated geneo.lms.db.TimeStampWithKey copy_attempts = 8;
   */
  copyAttempts: TimeStampWithKey[] = [];

  /**
   * @generated from field: repeated geneo.lms.db.TimeStampWithKey paste_attempts = 9;
   */
  pasteAttempts: TimeStampWithKey[] = [];

  /**
   * @generated from field: repeated google.protobuf.Timestamp right_click_attempts = 10;
   */
  rightClickAttempts: Timestamp[] = [];

  /**
   * @generated from field: repeated geneo.lms.db.TimeStampWithKey blocked_shortcuts = 11;
   */
  blockedShortcuts: TimeStampWithKey[] = [];

  /**
   * @generated from field: repeated geneo.lms.db.IdleTimeInformation idle_time_data = 12;
   */
  idleTimeData: IdleTimeInformation[] = [];

  /**
   * @generated from field: repeated google.protobuf.Timestamp multiple_sessions = 13;
   */
  multipleSessions: Timestamp[] = [];

  constructor(data?: PartialMessage<CreateProctoringLogsRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "geneo.lms.assessment.student.apis.CreateProctoringLogsRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "student_id", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 2, name: "assessment_id", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 3, name: "homework_session_id", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 5, name: "question_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "full_screen_exits", kind: "message", T: Timestamp, repeated: true },
    { no: 7, name: "tab_switches", kind: "message", T: Timestamp, repeated: true },
    { no: 8, name: "copy_attempts", kind: "message", T: TimeStampWithKey, repeated: true },
    { no: 9, name: "paste_attempts", kind: "message", T: TimeStampWithKey, repeated: true },
    { no: 10, name: "right_click_attempts", kind: "message", T: Timestamp, repeated: true },
    { no: 11, name: "blocked_shortcuts", kind: "message", T: TimeStampWithKey, repeated: true },
    { no: 12, name: "idle_time_data", kind: "message", T: IdleTimeInformation, repeated: true },
    { no: 13, name: "multiple_sessions", kind: "message", T: Timestamp, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): CreateProctoringLogsRequest {
    return new CreateProctoringLogsRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): CreateProctoringLogsRequest {
    return new CreateProctoringLogsRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): CreateProctoringLogsRequest {
    return new CreateProctoringLogsRequest().fromJsonString(jsonString, options);
  }

  static equals(a: CreateProctoringLogsRequest | PlainMessage<CreateProctoringLogsRequest> | undefined, b: CreateProctoringLogsRequest | PlainMessage<CreateProctoringLogsRequest> | undefined): boolean {
    return proto3.util.equals(CreateProctoringLogsRequest, a, b);
  }
}

/**
 * @generated from message geneo.lms.assessment.student.apis.CreateProctoringLogsResponse
 */
export class CreateProctoringLogsResponse extends Message<CreateProctoringLogsResponse> {
  /**
   * @generated from field: int32 status = 1;
   */
  status = 0;

  /**
   * @generated from field: string code = 2;
   */
  code = "";

  /**
   * @generated from field: string message = 3;
   */
  message = "";

  constructor(data?: PartialMessage<CreateProctoringLogsResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "geneo.lms.assessment.student.apis.CreateProctoringLogsResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "status", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 2, name: "code", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "message", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): CreateProctoringLogsResponse {
    return new CreateProctoringLogsResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): CreateProctoringLogsResponse {
    return new CreateProctoringLogsResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): CreateProctoringLogsResponse {
    return new CreateProctoringLogsResponse().fromJsonString(jsonString, options);
  }

  static equals(a: CreateProctoringLogsResponse | PlainMessage<CreateProctoringLogsResponse> | undefined, b: CreateProctoringLogsResponse | PlainMessage<CreateProctoringLogsResponse> | undefined): boolean {
    return proto3.util.equals(CreateProctoringLogsResponse, a, b);
  }
}

/**
 * @generated from message geneo.lms.assessment.student.apis.FetchStudentAssessmentResponseFetchV2Request
 */
export class FetchStudentAssessmentResponseFetchV2Request extends Message<FetchStudentAssessmentResponseFetchV2Request> {
  /**
   * @generated from field: int64 student_id = 1;
   */
  studentId = protoInt64.zero;

  /**
   * @generated from field: int64 assessment_id = 2;
   */
  assessmentId = protoInt64.zero;

  /**
   * @generated from field: optional int32 attempt_number = 3;
   */
  attemptNumber?: number;

  /**
   * @generated from field: optional geneo.lms.db.AttemptTypeEnum attempt_type = 4;
   */
  attemptType?: AttemptTypeEnum;

  constructor(data?: PartialMessage<FetchStudentAssessmentResponseFetchV2Request>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "geneo.lms.assessment.student.apis.FetchStudentAssessmentResponseFetchV2Request";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "student_id", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 2, name: "assessment_id", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 3, name: "attempt_number", kind: "scalar", T: 5 /* ScalarType.INT32 */, opt: true },
    { no: 4, name: "attempt_type", kind: "enum", T: proto3.getEnumType(AttemptTypeEnum), opt: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): FetchStudentAssessmentResponseFetchV2Request {
    return new FetchStudentAssessmentResponseFetchV2Request().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): FetchStudentAssessmentResponseFetchV2Request {
    return new FetchStudentAssessmentResponseFetchV2Request().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): FetchStudentAssessmentResponseFetchV2Request {
    return new FetchStudentAssessmentResponseFetchV2Request().fromJsonString(jsonString, options);
  }

  static equals(a: FetchStudentAssessmentResponseFetchV2Request | PlainMessage<FetchStudentAssessmentResponseFetchV2Request> | undefined, b: FetchStudentAssessmentResponseFetchV2Request | PlainMessage<FetchStudentAssessmentResponseFetchV2Request> | undefined): boolean {
    return proto3.util.equals(FetchStudentAssessmentResponseFetchV2Request, a, b);
  }
}

/**
 * @generated from message geneo.lms.assessment.student.apis.MultiSubjectMetrics
 */
export class MultiSubjectMetrics extends Message<MultiSubjectMetrics> {
  /**
   * @generated from field: int32 section_no = 1;
   */
  sectionNo = 0;

  /**
   * @generated from field: float time_duration_in_min = 2;
   */
  timeDurationInMin = 0;

  /**
   * @generated from field: int32 number_of_questions = 3;
   */
  numberOfQuestions = 0;

  /**
   * @generated from field: int32 number_of_correct_questions = 4;
   */
  numberOfCorrectQuestions = 0;

  /**
   * @generated from field: float class_subject_score = 5;
   */
  classSubjectScore = 0;

  /**
   * @generated from field: int32 subject_id = 6;
   */
  subjectId = 0;

  /**
   * @generated from field: geneo.content.db.DifficultyLevelEnum avg_difficulty_level = 7;
   */
  avgDifficultyLevel = DifficultyLevelEnum.DIFFICULTY_LEVEL_UNDEFINED;

  /**
   * @generated from field: optional int32 students_submission_count = 8;
   */
  studentsSubmissionCount?: number;

  /**
   * @generated from field: optional float class_subject_score_in_percent = 9;
   */
  classSubjectScoreInPercent?: number;

  /**
   * @generated from field: int32 class_subject_max_score = 10;
   */
  classSubjectMaxScore = 0;

  /**
   * @generated from field: geneo.common.db.Subject.SubjectEnum subject = 11;
   */
  subject = Subject_SubjectEnum.UNDEFINED;

  /**
   * @generated from field: optional string section_name = 12;
   */
  sectionName?: string;

  /**
   * @generated from field: optional string section_title = 13;
   */
  sectionTitle?: string;

  /**
   * @generated from field: optional geneo.lms.db.TaskStudentAttemptStatusEnum assessment_section_attempt_status = 16;
   */
  assessmentSectionAttemptStatus?: TaskStudentAttemptStatusEnum;

  constructor(data?: PartialMessage<MultiSubjectMetrics>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "geneo.lms.assessment.student.apis.MultiSubjectMetrics";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "section_no", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 2, name: "time_duration_in_min", kind: "scalar", T: 2 /* ScalarType.FLOAT */ },
    { no: 3, name: "number_of_questions", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 4, name: "number_of_correct_questions", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 5, name: "class_subject_score", kind: "scalar", T: 2 /* ScalarType.FLOAT */ },
    { no: 6, name: "subject_id", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 7, name: "avg_difficulty_level", kind: "enum", T: proto3.getEnumType(DifficultyLevelEnum) },
    { no: 8, name: "students_submission_count", kind: "scalar", T: 5 /* ScalarType.INT32 */, opt: true },
    { no: 9, name: "class_subject_score_in_percent", kind: "scalar", T: 2 /* ScalarType.FLOAT */, opt: true },
    { no: 10, name: "class_subject_max_score", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 11, name: "subject", kind: "enum", T: proto3.getEnumType(Subject_SubjectEnum) },
    { no: 12, name: "section_name", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 13, name: "section_title", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 16, name: "assessment_section_attempt_status", kind: "enum", T: proto3.getEnumType(TaskStudentAttemptStatusEnum), opt: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): MultiSubjectMetrics {
    return new MultiSubjectMetrics().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): MultiSubjectMetrics {
    return new MultiSubjectMetrics().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): MultiSubjectMetrics {
    return new MultiSubjectMetrics().fromJsonString(jsonString, options);
  }

  static equals(a: MultiSubjectMetrics | PlainMessage<MultiSubjectMetrics> | undefined, b: MultiSubjectMetrics | PlainMessage<MultiSubjectMetrics> | undefined): boolean {
    return proto3.util.equals(MultiSubjectMetrics, a, b);
  }
}

/**
 * @generated from message geneo.lms.assessment.student.apis.AssessmentStudentResponseV2
 */
export class AssessmentStudentResponseV2 extends Message<AssessmentStudentResponseV2> {
  /**
   * ID of the homework
   *
   * @generated from field: int64 assessment_id = 1;
   */
  assessmentId = protoInt64.zero;

  /**
   * ID of the student
   *
   * @generated from field: int64 student_id = 2;
   */
  studentId = protoInt64.zero;

  /**
   * Date when the task was commenced
   *
   * @generated from field: google.protobuf.Timestamp task_commence_date = 3;
   */
  taskCommenceDate?: Timestamp;

  /**
   * Target date for task completion
   *
   * @generated from field: google.protobuf.Timestamp task_target_date = 4;
   */
  taskTargetDate?: Timestamp;

  /**
   * Date when the task was completed
   *
   * @generated from field: google.protobuf.Timestamp task_completed_date = 5;
   */
  taskCompletedDate?: Timestamp;

  /**
   * Active status of the assessment
   *
   * @generated from field: geneo.lms.db.TaskActiveStatusEnum assessment_active_status = 6;
   */
  assessmentActiveStatus = TaskActiveStatusEnum.TASK_ACTIVE_STATUS_UNDEFINED;

  /**
   * Attempt status of the assessment
   *
   * @generated from field: geneo.lms.db.TaskStudentAttemptStatusEnum assessment_attempt_status = 7;
   */
  assessmentAttemptStatus = TaskStudentAttemptStatusEnum.TASK_STUDENT_STATUS_UNDEFINED;

  /**
   * Evaluation status of the homework
   *
   * @generated from field: geneo.lms.db.TaskEvaluationStatusEnum assessment_evaluation_status = 8;
   */
  assessmentEvaluationStatus = TaskEvaluationStatusEnum.TASK_EVALUATION_STATUS_UNDEFINED;

  /**
   * @generated from field: optional geneo.lms.db.AssessmentEnum assessment_type = 9;
   */
  assessmentType?: AssessmentEnum;

  /**
   * Metrics associated with the homework response
   *
   * @generated from field: geneo.lms.db.MetricsModel metrics = 10;
   */
  metrics?: MetricsModel;

  /**
   * List of student's responses to the homework questions
   *
   * @generated from field: repeated geneo.lms.db.StudentAssessmentResponse responses = 11;
   */
  responses: StudentAssessmentResponse[] = [];

  /**
   * Creation timestamp
   *
   * @generated from field: google.protobuf.Timestamp created_on = 12;
   */
  createdOn?: Timestamp;

  /**
   * Last modification timestamp
   *
   * @generated from field: optional google.protobuf.Timestamp modified_on = 13;
   */
  modifiedOn?: Timestamp;

  /**
   * @generated from field: repeated geneo.lms.db.CloudUpload user_uploads = 14;
   */
  userUploads: CloudUpload[] = [];

  /**
   * @generated from field: optional float attempt_spent_time_in_secs = 15;
   */
  attemptSpentTimeInSecs?: number;

  /**
   * @generated from field: repeated geneo.lms.db.AttemptStats attempt_info = 16;
   */
  attemptInfo: AttemptStats[] = [];

  /**
   * @generated from field: repeated geneo.lms.db.MultiSubjectSection multi_subject_sections = 17;
   */
  multiSubjectSections: MultiSubjectSection[] = [];

  /**
   * @generated from field: repeated geneo.lms.assessment.student.apis.MultiSubjectMetrics multi_subject_metrics = 18;
   */
  multiSubjectMetrics: MultiSubjectMetrics[] = [];

  /**
   * @generated from field: optional bool is_multi_subject_assessment_flow = 19;
   */
  isMultiSubjectAssessmentFlow?: boolean;

  /**
   * @generated from field: optional string set_name = 20;
   */
  setName?: string;

  /**
   * @generated from field: optional geneo.lms.db.TaskTeacherReview teacher_review = 21;
   */
  teacherReview?: TaskTeacherReview;

  /**
   * Project tasks only. For a collaborative project this carries the GROUP's
   * shared progress, not just this student's contribution.
   *
   * @generated from field: optional geneo.lms.db.TaskProjectProgress project_progress = 22;
   */
  projectProgress?: TaskProjectProgress;

  /**
   * @generated from field: optional bool is_collaborative = 23;
   */
  isCollaborative?: boolean;

  /**
   * @generated from field: optional int64 student_group_id = 24;
   */
  studentGroupId?: bigint;

  /**
   * @generated from field: optional string group_name = 25;
   */
  groupName?: string;

  /**
   * Send this back as base_group_version on the next progress update so a
   * teammate's newer work is never silently overwritten.
   *
   * @generated from field: optional int64 group_version = 26;
   */
  groupVersion?: bigint;

  /**
   * Project tasks only. The latest practical artifact per practical resource -
   * what the Geneo IoT editor last saved, so reopening the resource resumes
   * instead of starting blank. Resource-keyed, so the client reads the entry
   * whose resource_id is the resource it is opening.
   *
   * For a collaborative project this is the GROUP's copy, matching
   * project_progress above: a member sees the teammate's latest save, not their
   * own stale one.
   *
   * Empty is normal - a non-project task, or a practical nobody has saved yet.
   *
   * @generated from field: repeated geneo.lms.db.StudentPracticalResponse practical_responses = 27;
   */
  practicalResponses: StudentPracticalResponse[] = [];

  /**
   * @generated from field: repeated string completed_resource_ids = 28;
   */
  completedResourceIds: string[] = [];

  /**
   * @generated from field: repeated geneo.lms.assessment.student.apis.AssignedResourceInfo assigned_resources = 29;
   */
  assignedResources: AssignedResourceInfo[] = [];

  constructor(data?: PartialMessage<AssessmentStudentResponseV2>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "geneo.lms.assessment.student.apis.AssessmentStudentResponseV2";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "assessment_id", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 2, name: "student_id", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 3, name: "task_commence_date", kind: "message", T: Timestamp },
    { no: 4, name: "task_target_date", kind: "message", T: Timestamp },
    { no: 5, name: "task_completed_date", kind: "message", T: Timestamp },
    { no: 6, name: "assessment_active_status", kind: "enum", T: proto3.getEnumType(TaskActiveStatusEnum) },
    { no: 7, name: "assessment_attempt_status", kind: "enum", T: proto3.getEnumType(TaskStudentAttemptStatusEnum) },
    { no: 8, name: "assessment_evaluation_status", kind: "enum", T: proto3.getEnumType(TaskEvaluationStatusEnum) },
    { no: 9, name: "assessment_type", kind: "enum", T: proto3.getEnumType(AssessmentEnum), opt: true },
    { no: 10, name: "metrics", kind: "message", T: MetricsModel },
    { no: 11, name: "responses", kind: "message", T: StudentAssessmentResponse, repeated: true },
    { no: 12, name: "created_on", kind: "message", T: Timestamp },
    { no: 13, name: "modified_on", kind: "message", T: Timestamp, opt: true },
    { no: 14, name: "user_uploads", kind: "message", T: CloudUpload, repeated: true },
    { no: 15, name: "attempt_spent_time_in_secs", kind: "scalar", T: 2 /* ScalarType.FLOAT */, opt: true },
    { no: 16, name: "attempt_info", kind: "message", T: AttemptStats, repeated: true },
    { no: 17, name: "multi_subject_sections", kind: "message", T: MultiSubjectSection, repeated: true },
    { no: 18, name: "multi_subject_metrics", kind: "message", T: MultiSubjectMetrics, repeated: true },
    { no: 19, name: "is_multi_subject_assessment_flow", kind: "scalar", T: 8 /* ScalarType.BOOL */, opt: true },
    { no: 20, name: "set_name", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 21, name: "teacher_review", kind: "message", T: TaskTeacherReview, opt: true },
    { no: 22, name: "project_progress", kind: "message", T: TaskProjectProgress, opt: true },
    { no: 23, name: "is_collaborative", kind: "scalar", T: 8 /* ScalarType.BOOL */, opt: true },
    { no: 24, name: "student_group_id", kind: "scalar", T: 3 /* ScalarType.INT64 */, opt: true },
    { no: 25, name: "group_name", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 26, name: "group_version", kind: "scalar", T: 3 /* ScalarType.INT64 */, opt: true },
    { no: 27, name: "practical_responses", kind: "message", T: StudentPracticalResponse, repeated: true },
    { no: 28, name: "completed_resource_ids", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 29, name: "assigned_resources", kind: "message", T: AssignedResourceInfo, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): AssessmentStudentResponseV2 {
    return new AssessmentStudentResponseV2().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): AssessmentStudentResponseV2 {
    return new AssessmentStudentResponseV2().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): AssessmentStudentResponseV2 {
    return new AssessmentStudentResponseV2().fromJsonString(jsonString, options);
  }

  static equals(a: AssessmentStudentResponseV2 | PlainMessage<AssessmentStudentResponseV2> | undefined, b: AssessmentStudentResponseV2 | PlainMessage<AssessmentStudentResponseV2> | undefined): boolean {
    return proto3.util.equals(AssessmentStudentResponseV2, a, b);
  }
}

/**
 * @generated from message geneo.lms.assessment.student.apis.UpdateProjectResourceProgressRequest
 */
export class UpdateProjectResourceProgressRequest extends Message<UpdateProjectResourceProgressRequest> {
  /**
   * @generated from field: int64 student_id = 1;
   */
  studentId = protoInt64.zero;

  /**
   * @generated from field: int64 assessment_id = 2;
   */
  assessmentId = protoInt64.zero;

  /**
   * Resources the student has just completed. Additive - the server unions
   * these with what the group already has and never removes anything, so a
   * stale or partial client list cannot erase a teammate's progress.
   *
   * @generated from field: repeated string completed_resource_ids = 3;
   */
  completedResourceIds: string[] = [];

  /**
   * The acting student's own student_homework_session, for audit. Optional.
   *
   * @generated from field: optional int64 session_id = 4;
   */
  sessionId?: bigint;

  /**
   * group_version the client last read. Required once the project is
   * collaborative: a mismatch is rejected instead of overwriting newer work.
   *
   * @generated from field: optional int64 base_group_version = 5;
   */
  baseGroupVersion?: bigint;

  /**
   * Explicit "we are done" action. Progress alone never completes a project -
   * reaching 100% keeps the task IN_PROGRESS until a member submits.
   *
   * @generated from field: optional bool submit = 6;
   */
  submit?: boolean;

  /**
   * @generated from field: optional float time_spent_in_sec = 7;
   */
  timeSpentInSec?: number;

  /**
   * @generated from field: repeated geneo.lms.db.CloudUpload user_uploads = 8;
   */
  userUploads: CloudUpload[] = [];

  constructor(data?: PartialMessage<UpdateProjectResourceProgressRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "geneo.lms.assessment.student.apis.UpdateProjectResourceProgressRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "student_id", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 2, name: "assessment_id", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 3, name: "completed_resource_ids", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 4, name: "session_id", kind: "scalar", T: 3 /* ScalarType.INT64 */, opt: true },
    { no: 5, name: "base_group_version", kind: "scalar", T: 3 /* ScalarType.INT64 */, opt: true },
    { no: 6, name: "submit", kind: "scalar", T: 8 /* ScalarType.BOOL */, opt: true },
    { no: 7, name: "time_spent_in_sec", kind: "scalar", T: 2 /* ScalarType.FLOAT */, opt: true },
    { no: 8, name: "user_uploads", kind: "message", T: CloudUpload, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): UpdateProjectResourceProgressRequest {
    return new UpdateProjectResourceProgressRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): UpdateProjectResourceProgressRequest {
    return new UpdateProjectResourceProgressRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): UpdateProjectResourceProgressRequest {
    return new UpdateProjectResourceProgressRequest().fromJsonString(jsonString, options);
  }

  static equals(a: UpdateProjectResourceProgressRequest | PlainMessage<UpdateProjectResourceProgressRequest> | undefined, b: UpdateProjectResourceProgressRequest | PlainMessage<UpdateProjectResourceProgressRequest> | undefined): boolean {
    return proto3.util.equals(UpdateProjectResourceProgressRequest, a, b);
  }
}

/**
 * @generated from message geneo.lms.assessment.student.apis.UpdateProjectResourceProgressData
 */
export class UpdateProjectResourceProgressData extends Message<UpdateProjectResourceProgressData> {
  /**
   * @generated from field: optional int64 student_group_id = 1;
   */
  studentGroupId?: bigint;

  /**
   * @generated from field: optional string group_name = 2;
   */
  groupName?: string;

  /**
   * @generated from field: int64 group_version = 3;
   */
  groupVersion = protoInt64.zero;

  /**
   * @generated from field: geneo.lms.db.TaskProjectProgress group_progress = 4;
   */
  groupProgress?: TaskProjectProgress;

  /**
   * @generated from field: geneo.lms.db.TaskStudentAttemptStatusEnum attempt_status = 5;
   */
  attemptStatus = TaskStudentAttemptStatusEnum.TASK_STUDENT_STATUS_UNDEFINED;

  /**
   * Students sharing this progress (1 when the project has no groups).
   *
   * @generated from field: int32 member_count = 6;
   */
  memberCount = 0;

  /**
   * Whole-task progress across every assigned student, i.e. the figure held on
   * the section-wide "all members" group.
   *
   * @generated from field: float task_progress_percent = 7;
   */
  taskProgressPercent = 0;

  constructor(data?: PartialMessage<UpdateProjectResourceProgressData>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "geneo.lms.assessment.student.apis.UpdateProjectResourceProgressData";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "student_group_id", kind: "scalar", T: 3 /* ScalarType.INT64 */, opt: true },
    { no: 2, name: "group_name", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 3, name: "group_version", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 4, name: "group_progress", kind: "message", T: TaskProjectProgress },
    { no: 5, name: "attempt_status", kind: "enum", T: proto3.getEnumType(TaskStudentAttemptStatusEnum) },
    { no: 6, name: "member_count", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 7, name: "task_progress_percent", kind: "scalar", T: 2 /* ScalarType.FLOAT */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): UpdateProjectResourceProgressData {
    return new UpdateProjectResourceProgressData().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): UpdateProjectResourceProgressData {
    return new UpdateProjectResourceProgressData().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): UpdateProjectResourceProgressData {
    return new UpdateProjectResourceProgressData().fromJsonString(jsonString, options);
  }

  static equals(a: UpdateProjectResourceProgressData | PlainMessage<UpdateProjectResourceProgressData> | undefined, b: UpdateProjectResourceProgressData | PlainMessage<UpdateProjectResourceProgressData> | undefined): boolean {
    return proto3.util.equals(UpdateProjectResourceProgressData, a, b);
  }
}

/**
 * @generated from message geneo.lms.assessment.student.apis.UpdateProjectResourceProgressResponse
 */
export class UpdateProjectResourceProgressResponse extends Message<UpdateProjectResourceProgressResponse> {
  /**
   * @generated from field: int32 status = 1;
   */
  status = 0;

  /**
   * @generated from field: string code = 2;
   */
  code = "";

  /**
   * @generated from field: string message = 3;
   */
  message = "";

  /**
   * @generated from field: geneo.lms.assessment.student.apis.UpdateProjectResourceProgressData data = 4;
   */
  data?: UpdateProjectResourceProgressData;

  constructor(data?: PartialMessage<UpdateProjectResourceProgressResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "geneo.lms.assessment.student.apis.UpdateProjectResourceProgressResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "status", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 2, name: "code", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "message", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "data", kind: "message", T: UpdateProjectResourceProgressData },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): UpdateProjectResourceProgressResponse {
    return new UpdateProjectResourceProgressResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): UpdateProjectResourceProgressResponse {
    return new UpdateProjectResourceProgressResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): UpdateProjectResourceProgressResponse {
    return new UpdateProjectResourceProgressResponse().fromJsonString(jsonString, options);
  }

  static equals(a: UpdateProjectResourceProgressResponse | PlainMessage<UpdateProjectResourceProgressResponse> | undefined, b: UpdateProjectResourceProgressResponse | PlainMessage<UpdateProjectResourceProgressResponse> | undefined): boolean {
    return proto3.util.equals(UpdateProjectResourceProgressResponse, a, b);
  }
}

/**
 * @generated from message geneo.lms.assessment.student.apis.CreateStudentProjectSessionRequest
 */
export class CreateStudentProjectSessionRequest extends Message<CreateStudentProjectSessionRequest> {
  /**
   * Ignored: the student comes from the auth token.
   *
   * @generated from field: int64 student_id = 1;
   */
  studentId = protoInt64.zero;

  /**
   * @generated from field: int64 assessment_id = 2;
   */
  assessmentId = protoInt64.zero;

  /**
   * Ignored: school, class and section come from the student's assignment.
   *
   * @generated from field: int32 school_id = 3;
   */
  schoolId = 0;

  /**
   * Ignored: always the school's current academic year.
   *
   * @generated from field: int32 academic_year = 4;
   */
  academicYear = 0;

  /**
   * Ignored: see school_id.
   *
   * @generated from field: int32 class_id = 5;
   */
  classId = 0;

  /**
   * Ignored: see school_id.
   *
   * @generated from field: string section = 6;
   */
  section = "";

  /**
   * Resources this sitting sets out to cover; each must belong to the project.
   *
   * @generated from field: repeated string session_resource_ids = 8;
   */
  sessionResourceIds: string[] = [];

  /**
   * @generated from field: google.protobuf.Timestamp start_time = 9;
   */
  startTime?: Timestamp;

  /**
   * Ignored: a new session is always SESSION_STATUS_STARTED.
   *
   * @generated from field: geneo.lms.db.SessionStatusEnum session_status = 10;
   */
  sessionStatus = SessionStatusEnum.SESSION_STATUS_UNDEFINED;

  /**
   * Ignored: always SESSION_MODE_PROJECT.
   *
   * @generated from field: geneo.lms.db.SessionModeEnum session_mode = 11;
   */
  sessionMode = SessionModeEnum.SESSION_MODE_UNDEFINED;

  constructor(data?: PartialMessage<CreateStudentProjectSessionRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "geneo.lms.assessment.student.apis.CreateStudentProjectSessionRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "student_id", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 2, name: "assessment_id", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 3, name: "school_id", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 4, name: "academic_year", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 5, name: "class_id", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 6, name: "section", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 8, name: "session_resource_ids", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 9, name: "start_time", kind: "message", T: Timestamp },
    { no: 10, name: "session_status", kind: "enum", T: proto3.getEnumType(SessionStatusEnum) },
    { no: 11, name: "session_mode", kind: "enum", T: proto3.getEnumType(SessionModeEnum) },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): CreateStudentProjectSessionRequest {
    return new CreateStudentProjectSessionRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): CreateStudentProjectSessionRequest {
    return new CreateStudentProjectSessionRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): CreateStudentProjectSessionRequest {
    return new CreateStudentProjectSessionRequest().fromJsonString(jsonString, options);
  }

  static equals(a: CreateStudentProjectSessionRequest | PlainMessage<CreateStudentProjectSessionRequest> | undefined, b: CreateStudentProjectSessionRequest | PlainMessage<CreateStudentProjectSessionRequest> | undefined): boolean {
    return proto3.util.equals(CreateStudentProjectSessionRequest, a, b);
  }
}

/**
 * @generated from message geneo.lms.assessment.student.apis.CreateStudentProjectSessionResponse
 */
export class CreateStudentProjectSessionResponse extends Message<CreateStudentProjectSessionResponse> {
  /**
   * @generated from field: int32 status = 1;
   */
  status = 0;

  /**
   * @generated from field: string code = 2;
   */
  code = "";

  /**
   * @generated from field: string message = 3;
   */
  message = "";

  /**
   * @generated from field: int64 student_project_session_id = 4;
   */
  studentProjectSessionId = protoInt64.zero;

  constructor(data?: PartialMessage<CreateStudentProjectSessionResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "geneo.lms.assessment.student.apis.CreateStudentProjectSessionResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "status", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 2, name: "code", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "message", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "student_project_session_id", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): CreateStudentProjectSessionResponse {
    return new CreateStudentProjectSessionResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): CreateStudentProjectSessionResponse {
    return new CreateStudentProjectSessionResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): CreateStudentProjectSessionResponse {
    return new CreateStudentProjectSessionResponse().fromJsonString(jsonString, options);
  }

  static equals(a: CreateStudentProjectSessionResponse | PlainMessage<CreateStudentProjectSessionResponse> | undefined, b: CreateStudentProjectSessionResponse | PlainMessage<CreateStudentProjectSessionResponse> | undefined): boolean {
    return proto3.util.equals(CreateStudentProjectSessionResponse, a, b);
  }
}

/**
 * @generated from message geneo.lms.assessment.student.apis.UpdateStudentProjectSessionRequest
 */
export class UpdateStudentProjectSessionRequest extends Message<UpdateStudentProjectSessionRequest> {
  /**
   * @generated from field: int64 student_project_session_id = 1;
   */
  studentProjectSessionId = protoInt64.zero;

  /**
   * @generated from field: int64 student_id = 2;
   */
  studentId = protoInt64.zero;

  /**
   * @generated from field: int64 assessment_id = 3;
   */
  assessmentId = protoInt64.zero;

  /**
   * @generated from field: geneo.lms.db.SessionStatusEnum session_status = 4;
   */
  sessionStatus = SessionStatusEnum.SESSION_STATUS_UNDEFINED;

  /**
   * @generated from field: optional google.protobuf.Timestamp end_time = 5;
   */
  endTime?: Timestamp;

  /**
   * The learn-flow metrics blob, client-computed. completed_resource_ids inside
   * it is what gets forwarded to the group progress engine.
   *
   * @generated from field: optional geneo.lms.db.StudentProjectSessionMetrics metrics = 6;
   */
  metrics?: StudentProjectSessionMetrics;

  /**
   * group_version the client last read. Required once the project is
   * collaborative: a mismatch is rejected instead of overwriting newer work.
   *
   * @generated from field: optional int64 base_group_version = 7;
   */
  baseGroupVersion?: bigint;

  /**
   * Explicit "we are done". Reaching 100% alone never completes a project.
   *
   * @generated from field: optional bool submit = 8;
   */
  submit?: boolean;

  /**
   * @generated from field: optional float time_spent_in_sec = 9;
   */
  timeSpentInSec?: number;

  constructor(data?: PartialMessage<UpdateStudentProjectSessionRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "geneo.lms.assessment.student.apis.UpdateStudentProjectSessionRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "student_project_session_id", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 2, name: "student_id", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 3, name: "assessment_id", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 4, name: "session_status", kind: "enum", T: proto3.getEnumType(SessionStatusEnum) },
    { no: 5, name: "end_time", kind: "message", T: Timestamp, opt: true },
    { no: 6, name: "metrics", kind: "message", T: StudentProjectSessionMetrics, opt: true },
    { no: 7, name: "base_group_version", kind: "scalar", T: 3 /* ScalarType.INT64 */, opt: true },
    { no: 8, name: "submit", kind: "scalar", T: 8 /* ScalarType.BOOL */, opt: true },
    { no: 9, name: "time_spent_in_sec", kind: "scalar", T: 2 /* ScalarType.FLOAT */, opt: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): UpdateStudentProjectSessionRequest {
    return new UpdateStudentProjectSessionRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): UpdateStudentProjectSessionRequest {
    return new UpdateStudentProjectSessionRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): UpdateStudentProjectSessionRequest {
    return new UpdateStudentProjectSessionRequest().fromJsonString(jsonString, options);
  }

  static equals(a: UpdateStudentProjectSessionRequest | PlainMessage<UpdateStudentProjectSessionRequest> | undefined, b: UpdateStudentProjectSessionRequest | PlainMessage<UpdateStudentProjectSessionRequest> | undefined): boolean {
    return proto3.util.equals(UpdateStudentProjectSessionRequest, a, b);
  }
}

/**
 * @generated from message geneo.lms.assessment.student.apis.UpdateStudentProjectSessionResponse
 */
export class UpdateStudentProjectSessionResponse extends Message<UpdateStudentProjectSessionResponse> {
  /**
   * @generated from field: int32 status = 1;
   */
  status = 0;

  /**
   * @generated from field: string code = 2;
   */
  code = "";

  /**
   * @generated from field: string message = 3;
   */
  message = "";

  /**
   * @generated from field: int64 student_project_session_id = 4;
   */
  studentProjectSessionId = protoInt64.zero;

  /**
   * Reuses the existing message rather than defining a parallel one, so the
   * client's group-state handling is identical to updateProjectResourceProgress.
   *
   * @generated from field: optional geneo.lms.assessment.student.apis.UpdateProjectResourceProgressData progress = 5;
   */
  progress?: UpdateProjectResourceProgressData;

  constructor(data?: PartialMessage<UpdateStudentProjectSessionResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "geneo.lms.assessment.student.apis.UpdateStudentProjectSessionResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "status", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 2, name: "code", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "message", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "student_project_session_id", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 5, name: "progress", kind: "message", T: UpdateProjectResourceProgressData, opt: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): UpdateStudentProjectSessionResponse {
    return new UpdateStudentProjectSessionResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): UpdateStudentProjectSessionResponse {
    return new UpdateStudentProjectSessionResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): UpdateStudentProjectSessionResponse {
    return new UpdateStudentProjectSessionResponse().fromJsonString(jsonString, options);
  }

  static equals(a: UpdateStudentProjectSessionResponse | PlainMessage<UpdateStudentProjectSessionResponse> | undefined, b: UpdateStudentProjectSessionResponse | PlainMessage<UpdateStudentProjectSessionResponse> | undefined): boolean {
    return proto3.util.equals(UpdateStudentProjectSessionResponse, a, b);
  }
}

/**
 * @generated from message geneo.lms.assessment.student.apis.GetStudentPreviousProjectSessionRequest
 */
export class GetStudentPreviousProjectSessionRequest extends Message<GetStudentPreviousProjectSessionRequest> {
  /**
   * @generated from field: int64 student_id = 1;
   */
  studentId = protoInt64.zero;

  /**
   * @generated from field: int64 assessment_id = 2;
   */
  assessmentId = protoInt64.zero;

  constructor(data?: PartialMessage<GetStudentPreviousProjectSessionRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "geneo.lms.assessment.student.apis.GetStudentPreviousProjectSessionRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "student_id", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 2, name: "assessment_id", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetStudentPreviousProjectSessionRequest {
    return new GetStudentPreviousProjectSessionRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetStudentPreviousProjectSessionRequest {
    return new GetStudentPreviousProjectSessionRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetStudentPreviousProjectSessionRequest {
    return new GetStudentPreviousProjectSessionRequest().fromJsonString(jsonString, options);
  }

  static equals(a: GetStudentPreviousProjectSessionRequest | PlainMessage<GetStudentPreviousProjectSessionRequest> | undefined, b: GetStudentPreviousProjectSessionRequest | PlainMessage<GetStudentPreviousProjectSessionRequest> | undefined): boolean {
    return proto3.util.equals(GetStudentPreviousProjectSessionRequest, a, b);
  }
}

/**
 * @generated from message geneo.lms.assessment.student.apis.StudentPreviousProjectSession
 */
export class StudentPreviousProjectSession extends Message<StudentPreviousProjectSession> {
  /**
   * @generated from field: int64 student_id = 1;
   */
  studentId = protoInt64.zero;

  /**
   * @generated from field: int64 assessment_id = 2;
   */
  assessmentId = protoInt64.zero;

  /**
   * Union across this student's sittings, and across the group for a
   * collaborative project.
   *
   * @generated from field: repeated string completed_resource_ids = 3;
   */
  completedResourceIds: string[] = [];

  /**
   * @generated from field: optional bool is_collaborative = 4;
   */
  isCollaborative?: boolean;

  /**
   * @generated from field: optional int64 student_group_id = 5;
   */
  studentGroupId?: bigint;

  /**
   * @generated from field: optional string group_name = 6;
   */
  groupName?: string;

  /**
   * The client must echo this back on the next update or the write is rejected.
   *
   * @generated from field: optional int64 group_version = 7;
   */
  groupVersion?: bigint;

  /**
   * @generated from field: optional int64 last_student_project_session_id = 8;
   */
  lastStudentProjectSessionId?: bigint;

  /**
   * @generated from field: optional google.protobuf.Timestamp last_session_time = 9;
   */
  lastSessionTime?: Timestamp;

  constructor(data?: PartialMessage<StudentPreviousProjectSession>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "geneo.lms.assessment.student.apis.StudentPreviousProjectSession";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "student_id", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 2, name: "assessment_id", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 3, name: "completed_resource_ids", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 4, name: "is_collaborative", kind: "scalar", T: 8 /* ScalarType.BOOL */, opt: true },
    { no: 5, name: "student_group_id", kind: "scalar", T: 3 /* ScalarType.INT64 */, opt: true },
    { no: 6, name: "group_name", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 7, name: "group_version", kind: "scalar", T: 3 /* ScalarType.INT64 */, opt: true },
    { no: 8, name: "last_student_project_session_id", kind: "scalar", T: 3 /* ScalarType.INT64 */, opt: true },
    { no: 9, name: "last_session_time", kind: "message", T: Timestamp, opt: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): StudentPreviousProjectSession {
    return new StudentPreviousProjectSession().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): StudentPreviousProjectSession {
    return new StudentPreviousProjectSession().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): StudentPreviousProjectSession {
    return new StudentPreviousProjectSession().fromJsonString(jsonString, options);
  }

  static equals(a: StudentPreviousProjectSession | PlainMessage<StudentPreviousProjectSession> | undefined, b: StudentPreviousProjectSession | PlainMessage<StudentPreviousProjectSession> | undefined): boolean {
    return proto3.util.equals(StudentPreviousProjectSession, a, b);
  }
}

/**
 * @generated from message geneo.lms.assessment.student.apis.StudentPreviousProjectSessionResponse
 */
export class StudentPreviousProjectSessionResponse extends Message<StudentPreviousProjectSessionResponse> {
  /**
   * @generated from field: int32 status = 1;
   */
  status = 0;

  /**
   * @generated from field: string code = 2;
   */
  code = "";

  /**
   * @generated from field: string message = 3;
   */
  message = "";

  /**
   * @generated from field: geneo.lms.assessment.student.apis.StudentPreviousProjectSession data = 4;
   */
  data?: StudentPreviousProjectSession;

  constructor(data?: PartialMessage<StudentPreviousProjectSessionResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "geneo.lms.assessment.student.apis.StudentPreviousProjectSessionResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "status", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 2, name: "code", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "message", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "data", kind: "message", T: StudentPreviousProjectSession },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): StudentPreviousProjectSessionResponse {
    return new StudentPreviousProjectSessionResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): StudentPreviousProjectSessionResponse {
    return new StudentPreviousProjectSessionResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): StudentPreviousProjectSessionResponse {
    return new StudentPreviousProjectSessionResponse().fromJsonString(jsonString, options);
  }

  static equals(a: StudentPreviousProjectSessionResponse | PlainMessage<StudentPreviousProjectSessionResponse> | undefined, b: StudentPreviousProjectSessionResponse | PlainMessage<StudentPreviousProjectSessionResponse> | undefined): boolean {
    return proto3.util.equals(StudentPreviousProjectSessionResponse, a, b);
  }
}

/**
 * @generated from message geneo.lms.assessment.student.apis.CreateStudentProjectResourceSessionRequest
 */
export class CreateStudentProjectResourceSessionRequest extends Message<CreateStudentProjectResourceSessionRequest> {
  /**
   * @generated from field: int64 student_id = 1;
   */
  studentId = protoInt64.zero;

  /**
   * @generated from field: string resource_id = 2;
   */
  resourceId = "";

  /**
   * @generated from field: int32 school_id = 3;
   */
  schoolId = 0;

  /**
   * @generated from field: int32 academic_year = 4;
   */
  academicYear = 0;

  /**
   * @generated from field: int32 class_id = 5;
   */
  classId = 0;

  /**
   * @generated from field: string section = 6;
   */
  section = "";

  /**
   * @generated from field: geneo.common.db.Subject.SubjectEnum subject = 7;
   */
  subject = Subject_SubjectEnum.UNDEFINED;

  /**
   * @generated from field: int32 module_id = 8;
   */
  moduleId = 0;

  /**
   * @generated from field: int64 student_project_session_id = 9;
   */
  studentProjectSessionId = protoInt64.zero;

  /**
   * @generated from field: geneo.lms.db.SessionModeEnum session_mode = 10;
   */
  sessionMode = SessionModeEnum.SESSION_MODE_UNDEFINED;

  /**
   * @generated from field: google.protobuf.Timestamp start_time = 11;
   */
  startTime?: Timestamp;

  /**
   * @generated from field: geneo.lms.db.SessionStatusEnum session_status = 12;
   */
  sessionStatus = SessionStatusEnum.SESSION_STATUS_UNDEFINED;

  /**
   * @generated from field: int64 assessment_id = 13;
   */
  assessmentId = protoInt64.zero;

  /**
   * Ignored if supplied; the server copies it from the project's own resource
   * list so it always matches the lesson plan the resource really came from.
   *
   * @generated from field: optional string lesson_id = 14;
   */
  lessonId?: string;

  constructor(data?: PartialMessage<CreateStudentProjectResourceSessionRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "geneo.lms.assessment.student.apis.CreateStudentProjectResourceSessionRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "student_id", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 2, name: "resource_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "school_id", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 4, name: "academic_year", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 5, name: "class_id", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 6, name: "section", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 7, name: "subject", kind: "enum", T: proto3.getEnumType(Subject_SubjectEnum) },
    { no: 8, name: "module_id", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 9, name: "student_project_session_id", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 10, name: "session_mode", kind: "enum", T: proto3.getEnumType(SessionModeEnum) },
    { no: 11, name: "start_time", kind: "message", T: Timestamp },
    { no: 12, name: "session_status", kind: "enum", T: proto3.getEnumType(SessionStatusEnum) },
    { no: 13, name: "assessment_id", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 14, name: "lesson_id", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): CreateStudentProjectResourceSessionRequest {
    return new CreateStudentProjectResourceSessionRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): CreateStudentProjectResourceSessionRequest {
    return new CreateStudentProjectResourceSessionRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): CreateStudentProjectResourceSessionRequest {
    return new CreateStudentProjectResourceSessionRequest().fromJsonString(jsonString, options);
  }

  static equals(a: CreateStudentProjectResourceSessionRequest | PlainMessage<CreateStudentProjectResourceSessionRequest> | undefined, b: CreateStudentProjectResourceSessionRequest | PlainMessage<CreateStudentProjectResourceSessionRequest> | undefined): boolean {
    return proto3.util.equals(CreateStudentProjectResourceSessionRequest, a, b);
  }
}

/**
 * @generated from message geneo.lms.assessment.student.apis.CreateStudentProjectResourceSessionResponse
 */
export class CreateStudentProjectResourceSessionResponse extends Message<CreateStudentProjectResourceSessionResponse> {
  /**
   * @generated from field: int32 status = 1;
   */
  status = 0;

  /**
   * @generated from field: string code = 2;
   */
  code = "";

  /**
   * @generated from field: string message = 3;
   */
  message = "";

  /**
   * @generated from field: int64 student_project_resource_session_id = 4;
   */
  studentProjectResourceSessionId = protoInt64.zero;

  constructor(data?: PartialMessage<CreateStudentProjectResourceSessionResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "geneo.lms.assessment.student.apis.CreateStudentProjectResourceSessionResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "status", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 2, name: "code", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "message", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "student_project_resource_session_id", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): CreateStudentProjectResourceSessionResponse {
    return new CreateStudentProjectResourceSessionResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): CreateStudentProjectResourceSessionResponse {
    return new CreateStudentProjectResourceSessionResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): CreateStudentProjectResourceSessionResponse {
    return new CreateStudentProjectResourceSessionResponse().fromJsonString(jsonString, options);
  }

  static equals(a: CreateStudentProjectResourceSessionResponse | PlainMessage<CreateStudentProjectResourceSessionResponse> | undefined, b: CreateStudentProjectResourceSessionResponse | PlainMessage<CreateStudentProjectResourceSessionResponse> | undefined): boolean {
    return proto3.util.equals(CreateStudentProjectResourceSessionResponse, a, b);
  }
}

/**
 * @generated from message geneo.lms.assessment.student.apis.UpdateStudentProjectResourceSessionRequest
 */
export class UpdateStudentProjectResourceSessionRequest extends Message<UpdateStudentProjectResourceSessionRequest> {
  /**
   * @generated from field: int64 student_project_resource_session_id = 1;
   */
  studentProjectResourceSessionId = protoInt64.zero;

  /**
   * @generated from field: int64 student_id = 2;
   */
  studentId = protoInt64.zero;

  /**
   * @generated from field: string resource_id = 3;
   */
  resourceId = "";

  /**
   * @generated from field: geneo.lms.db.SessionStatusEnum session_status = 4;
   */
  sessionStatus = SessionStatusEnum.SESSION_STATUS_UNDEFINED;

  /**
   * @generated from field: repeated geneo.lms.db.StudentContentResponse response = 5;
   */
  response: StudentContentResponse[] = [];

  /**
   * @generated from field: optional google.protobuf.Timestamp end_time = 6;
   */
  endTime?: Timestamp;

  /**
   * @generated from field: optional geneo.lms.db.StudentResourceSessionMetrics metrics = 7;
   */
  metrics?: StudentResourceSessionMetrics;

  /**
   * Practical resources only (RESOURCE_TYPE_PRACTICAL). The Geneo IoT editor's
   * saved project - the object it logs under its own `project` key. Sending it
   * stores it on this session row AND replaces the group's copy for this
   * resource, projected onto every member.
   *
   * @generated from field: optional geneo.content.db.PracticalProject practical_response = 8;
   */
  practicalResponse?: PracticalProject;

  /**
   * The group version the editor loaded. With practical_response on a group
   * project, a mismatch is rejected (ABORTED) so a teammate's newer code is not
   * overwritten. Omitted by older apps, which keep last-write-wins.
   *
   * @generated from field: optional int64 base_group_version = 9;
   */
  baseGroupVersion?: bigint;

  constructor(data?: PartialMessage<UpdateStudentProjectResourceSessionRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "geneo.lms.assessment.student.apis.UpdateStudentProjectResourceSessionRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "student_project_resource_session_id", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 2, name: "student_id", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 3, name: "resource_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "session_status", kind: "enum", T: proto3.getEnumType(SessionStatusEnum) },
    { no: 5, name: "response", kind: "message", T: StudentContentResponse, repeated: true },
    { no: 6, name: "end_time", kind: "message", T: Timestamp, opt: true },
    { no: 7, name: "metrics", kind: "message", T: StudentResourceSessionMetrics, opt: true },
    { no: 8, name: "practical_response", kind: "message", T: PracticalProject, opt: true },
    { no: 9, name: "base_group_version", kind: "scalar", T: 3 /* ScalarType.INT64 */, opt: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): UpdateStudentProjectResourceSessionRequest {
    return new UpdateStudentProjectResourceSessionRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): UpdateStudentProjectResourceSessionRequest {
    return new UpdateStudentProjectResourceSessionRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): UpdateStudentProjectResourceSessionRequest {
    return new UpdateStudentProjectResourceSessionRequest().fromJsonString(jsonString, options);
  }

  static equals(a: UpdateStudentProjectResourceSessionRequest | PlainMessage<UpdateStudentProjectResourceSessionRequest> | undefined, b: UpdateStudentProjectResourceSessionRequest | PlainMessage<UpdateStudentProjectResourceSessionRequest> | undefined): boolean {
    return proto3.util.equals(UpdateStudentProjectResourceSessionRequest, a, b);
  }
}

/**
 * @generated from message geneo.lms.assessment.student.apis.UpdateStudentProjectResourceSessionResponse
 */
export class UpdateStudentProjectResourceSessionResponse extends Message<UpdateStudentProjectResourceSessionResponse> {
  /**
   * @generated from field: int32 status = 1;
   */
  status = 0;

  /**
   * @generated from field: string code = 2;
   */
  code = "";

  /**
   * @generated from field: string message = 3;
   */
  message = "";

  /**
   * @generated from field: int64 student_project_resource_session_id = 4;
   */
  studentProjectResourceSessionId = protoInt64.zero;

  /**
   * Present only when a practical_response was accepted for a collaborative
   * project. The group's shared state changed, so the client MUST carry this
   * into its next updateProjectResourceProgress call or that call is Aborted.
   *
   * @generated from field: optional int64 group_version = 5;
   */
  groupVersion?: bigint;

  constructor(data?: PartialMessage<UpdateStudentProjectResourceSessionResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "geneo.lms.assessment.student.apis.UpdateStudentProjectResourceSessionResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "status", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 2, name: "code", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "message", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "student_project_resource_session_id", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 5, name: "group_version", kind: "scalar", T: 3 /* ScalarType.INT64 */, opt: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): UpdateStudentProjectResourceSessionResponse {
    return new UpdateStudentProjectResourceSessionResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): UpdateStudentProjectResourceSessionResponse {
    return new UpdateStudentProjectResourceSessionResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): UpdateStudentProjectResourceSessionResponse {
    return new UpdateStudentProjectResourceSessionResponse().fromJsonString(jsonString, options);
  }

  static equals(a: UpdateStudentProjectResourceSessionResponse | PlainMessage<UpdateStudentProjectResourceSessionResponse> | undefined, b: UpdateStudentProjectResourceSessionResponse | PlainMessage<UpdateStudentProjectResourceSessionResponse> | undefined): boolean {
    return proto3.util.equals(UpdateStudentProjectResourceSessionResponse, a, b);
  }
}

/**
 * @generated from message geneo.lms.assessment.student.apis.FetchStudentAssessmentResponseFetchV2Response
 */
export class FetchStudentAssessmentResponseFetchV2Response extends Message<FetchStudentAssessmentResponseFetchV2Response> {
  /**
   * @generated from field: int32 status = 1;
   */
  status = 0;

  /**
   * @generated from field: string code = 2;
   */
  code = "";

  /**
   * @generated from field: string message = 3;
   */
  message = "";

  /**
   * @generated from field: geneo.lms.assessment.student.apis.AssessmentStudentResponseV2 data = 4;
   */
  data?: AssessmentStudentResponseV2;

  constructor(data?: PartialMessage<FetchStudentAssessmentResponseFetchV2Response>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "geneo.lms.assessment.student.apis.FetchStudentAssessmentResponseFetchV2Response";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "status", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 2, name: "code", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "message", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "data", kind: "message", T: AssessmentStudentResponseV2 },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): FetchStudentAssessmentResponseFetchV2Response {
    return new FetchStudentAssessmentResponseFetchV2Response().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): FetchStudentAssessmentResponseFetchV2Response {
    return new FetchStudentAssessmentResponseFetchV2Response().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): FetchStudentAssessmentResponseFetchV2Response {
    return new FetchStudentAssessmentResponseFetchV2Response().fromJsonString(jsonString, options);
  }

  static equals(a: FetchStudentAssessmentResponseFetchV2Response | PlainMessage<FetchStudentAssessmentResponseFetchV2Response> | undefined, b: FetchStudentAssessmentResponseFetchV2Response | PlainMessage<FetchStudentAssessmentResponseFetchV2Response> | undefined): boolean {
    return proto3.util.equals(FetchStudentAssessmentResponseFetchV2Response, a, b);
  }
}

/**
 * @generated from message geneo.lms.assessment.student.apis.GilProjectInfo
 */
export class GilProjectInfo extends Message<GilProjectInfo> {
  /**
   * task.id
   *
   * @generated from field: int64 assessment_id = 1;
   */
  assessmentId = protoInt64.zero;

  /**
   * task.task_id
   *
   * @generated from field: string task_id = 2;
   */
  taskId = "";

  /**
   * @generated from field: string project_title = 3;
   */
  projectTitle = "";

  /**
   * The chapter the project was built from. A GIL project is a chapter, and its
   * chapter number is the "Project 05" a dashboard shows.
   *
   * @generated from field: optional int32 chapter_id = 4;
   */
  chapterId?: number;

  /**
   * @generated from field: optional int32 chapter_no = 5;
   */
  chapterNo?: number;

  /**
   * @generated from field: optional string chapter_name = 6;
   */
  chapterName?: string;

  /**
   * @generated from field: optional string poster_image_url = 7;
   */
  posterImageUrl?: string;

  /**
   * @generated from field: optional google.protobuf.Timestamp assigned_date = 8;
   */
  assignedDate?: Timestamp;

  /**
   * @generated from field: float max_marks = 9;
   */
  maxMarks = 0;

  constructor(data?: PartialMessage<GilProjectInfo>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "geneo.lms.assessment.student.apis.GilProjectInfo";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "assessment_id", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 2, name: "task_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "project_title", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "chapter_id", kind: "scalar", T: 5 /* ScalarType.INT32 */, opt: true },
    { no: 5, name: "chapter_no", kind: "scalar", T: 5 /* ScalarType.INT32 */, opt: true },
    { no: 6, name: "chapter_name", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 7, name: "poster_image_url", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 8, name: "assigned_date", kind: "message", T: Timestamp, opt: true },
    { no: 9, name: "max_marks", kind: "scalar", T: 2 /* ScalarType.FLOAT */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GilProjectInfo {
    return new GilProjectInfo().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GilProjectInfo {
    return new GilProjectInfo().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GilProjectInfo {
    return new GilProjectInfo().fromJsonString(jsonString, options);
  }

  static equals(a: GilProjectInfo | PlainMessage<GilProjectInfo> | undefined, b: GilProjectInfo | PlainMessage<GilProjectInfo> | undefined): boolean {
    return proto3.util.equals(GilProjectInfo, a, b);
  }
}

/**
 * @generated from message geneo.lms.assessment.student.apis.GilTimeSpent
 */
export class GilTimeSpent extends Message<GilTimeSpent> {
  /**
   * @generated from field: float video_activity_book_time_in_sec = 1;
   */
  videoActivityBookTimeInSec = 0;

  /**
   * @generated from field: float coding_time_in_sec = 2;
   */
  codingTimeInSec = 0;

  /**
   * @generated from field: float total_time_in_sec = 3;
   */
  totalTimeInSec = 0;

  constructor(data?: PartialMessage<GilTimeSpent>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "geneo.lms.assessment.student.apis.GilTimeSpent";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "video_activity_book_time_in_sec", kind: "scalar", T: 2 /* ScalarType.FLOAT */ },
    { no: 2, name: "coding_time_in_sec", kind: "scalar", T: 2 /* ScalarType.FLOAT */ },
    { no: 3, name: "total_time_in_sec", kind: "scalar", T: 2 /* ScalarType.FLOAT */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GilTimeSpent {
    return new GilTimeSpent().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GilTimeSpent {
    return new GilTimeSpent().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GilTimeSpent {
    return new GilTimeSpent().fromJsonString(jsonString, options);
  }

  static equals(a: GilTimeSpent | PlainMessage<GilTimeSpent> | undefined, b: GilTimeSpent | PlainMessage<GilTimeSpent> | undefined): boolean {
    return proto3.util.equals(GilTimeSpent, a, b);
  }
}

/**
 * @generated from message geneo.lms.assessment.student.apis.GilProjectScore
 */
export class GilProjectScore extends Message<GilProjectScore> {
  /**
   * @generated from field: float obtained_marks = 1;
   */
  obtainedMarks = 0;

  /**
   * @generated from field: float max_marks = 2;
   */
  maxMarks = 0;

  /**
   * False until a teacher has marked the student. obtained_marks is then 0 and
   * must not be shown as a real score.
   *
   * @generated from field: bool is_graded = 3;
   */
  isGraded = false;

  constructor(data?: PartialMessage<GilProjectScore>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "geneo.lms.assessment.student.apis.GilProjectScore";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "obtained_marks", kind: "scalar", T: 2 /* ScalarType.FLOAT */ },
    { no: 2, name: "max_marks", kind: "scalar", T: 2 /* ScalarType.FLOAT */ },
    { no: 3, name: "is_graded", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GilProjectScore {
    return new GilProjectScore().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GilProjectScore {
    return new GilProjectScore().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GilProjectScore {
    return new GilProjectScore().fromJsonString(jsonString, options);
  }

  static equals(a: GilProjectScore | PlainMessage<GilProjectScore> | undefined, b: GilProjectScore | PlainMessage<GilProjectScore> | undefined): boolean {
    return proto3.util.equals(GilProjectScore, a, b);
  }
}

/**
 * @generated from message geneo.lms.assessment.student.apis.GilClassSectionInfo
 */
export class GilClassSectionInfo extends Message<GilClassSectionInfo> {
  /**
   * school_class_section_id
   *
   * @generated from field: int64 section_id = 1;
   */
  sectionId = protoInt64.zero;

  /**
   * @generated from field: optional string class_name = 2;
   */
  className?: string;

  /**
   * @generated from field: optional string section_name = 3;
   */
  sectionName?: string;

  /**
   * @generated from field: optional int32 academic_year_id = 4;
   */
  academicYearId?: number;

  /**
   * @generated from field: optional geneo.common.db.AcademicYear.Enum academic_year = 5;
   */
  academicYear?: AcademicYear_Enum;

  constructor(data?: PartialMessage<GilClassSectionInfo>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "geneo.lms.assessment.student.apis.GilClassSectionInfo";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "section_id", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 2, name: "class_name", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 3, name: "section_name", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 4, name: "academic_year_id", kind: "scalar", T: 5 /* ScalarType.INT32 */, opt: true },
    { no: 5, name: "academic_year", kind: "enum", T: proto3.getEnumType(AcademicYear_Enum), opt: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GilClassSectionInfo {
    return new GilClassSectionInfo().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GilClassSectionInfo {
    return new GilClassSectionInfo().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GilClassSectionInfo {
    return new GilClassSectionInfo().fromJsonString(jsonString, options);
  }

  static equals(a: GilClassSectionInfo | PlainMessage<GilClassSectionInfo> | undefined, b: GilClassSectionInfo | PlainMessage<GilClassSectionInfo> | undefined): boolean {
    return proto3.util.equals(GilClassSectionInfo, a, b);
  }
}

/**
 * One image or video in a project gallery, tagged with where it came from.
 *
 * @generated from message geneo.lms.assessment.student.apis.GilGalleryItem
 */
export class GilGalleryItem extends Message<GilGalleryItem> {
  /**
   * @generated from field: int64 assessment_id = 1;
   */
  assessmentId = protoInt64.zero;

  /**
   * @generated from field: string project_title = 2;
   */
  projectTitle = "";

  /**
   * @generated from field: optional int64 student_group_id = 3;
   */
  studentGroupId?: bigint;

  /**
   * @generated from field: optional string group_name = 4;
   */
  groupName?: string;

  /**
   * @generated from field: geneo.lms.db.CloudUpload upload = 5;
   */
  upload?: CloudUpload;

  constructor(data?: PartialMessage<GilGalleryItem>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "geneo.lms.assessment.student.apis.GilGalleryItem";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "assessment_id", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 2, name: "project_title", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "student_group_id", kind: "scalar", T: 3 /* ScalarType.INT64 */, opt: true },
    { no: 4, name: "group_name", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 5, name: "upload", kind: "message", T: CloudUpload },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GilGalleryItem {
    return new GilGalleryItem().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GilGalleryItem {
    return new GilGalleryItem().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GilGalleryItem {
    return new GilGalleryItem().fromJsonString(jsonString, options);
  }

  static equals(a: GilGalleryItem | PlainMessage<GilGalleryItem> | undefined, b: GilGalleryItem | PlainMessage<GilGalleryItem> | undefined): boolean {
    return proto3.util.equals(GilGalleryItem, a, b);
  }
}

/**
 * Dashboard 1 - one student, one project.
 *
 * @generated from message geneo.lms.assessment.student.apis.GetGilStudentProjectReportRequest
 */
export class GetGilStudentProjectReportRequest extends Message<GetGilStudentProjectReportRequest> {
  /**
   * @generated from field: int64 student_id = 1;
   */
  studentId = protoInt64.zero;

  /**
   * @generated from field: int64 assessment_id = 2;
   */
  assessmentId = protoInt64.zero;

  constructor(data?: PartialMessage<GetGilStudentProjectReportRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "geneo.lms.assessment.student.apis.GetGilStudentProjectReportRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "student_id", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 2, name: "assessment_id", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetGilStudentProjectReportRequest {
    return new GetGilStudentProjectReportRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetGilStudentProjectReportRequest {
    return new GetGilStudentProjectReportRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetGilStudentProjectReportRequest {
    return new GetGilStudentProjectReportRequest().fromJsonString(jsonString, options);
  }

  static equals(a: GetGilStudentProjectReportRequest | PlainMessage<GetGilStudentProjectReportRequest> | undefined, b: GetGilStudentProjectReportRequest | PlainMessage<GetGilStudentProjectReportRequest> | undefined): boolean {
    return proto3.util.equals(GetGilStudentProjectReportRequest, a, b);
  }
}

/**
 * @generated from message geneo.lms.assessment.student.apis.GilStudentProjectReport
 */
export class GilStudentProjectReport extends Message<GilStudentProjectReport> {
  /**
   * @generated from field: geneo.lms.assessment.student.apis.GilProjectInfo project = 1;
   */
  project?: GilProjectInfo;

  /**
   * @generated from field: int64 student_id = 2;
   */
  studentId = protoInt64.zero;

  /**
   * @generated from field: string student_name = 3;
   */
  studentName = "";

  /**
   * @generated from field: geneo.lms.assessment.student.apis.GilClassSectionInfo class_section = 4;
   */
  classSection?: GilClassSectionInfo;

  /**
   * Set only for a collaborative project.
   *
   * @generated from field: optional int64 student_group_id = 5;
   */
  studentGroupId?: bigint;

  /**
   * @generated from field: optional string group_name = 6;
   */
  groupName?: string;

  /**
   * @generated from field: geneo.lms.assessment.student.apis.GilProjectStatusEnum status = 7;
   */
  status = GilProjectStatusEnum.GIL_PROJECT_STATUS_UNDEFINED;

  /**
   * @generated from field: geneo.lms.assessment.student.apis.GilTimeSpent time_spent = 8;
   */
  timeSpent?: GilTimeSpent;

  /**
   * @generated from field: geneo.lms.assessment.student.apis.GilProjectScore project_score = 9;
   */
  projectScore?: GilProjectScore;

  /**
   * Gallery: the uploaded images/videos. practical_responses (the student's
   * code) is filled only when there are no uploads; when both are empty the
   * gallery is hidden.
   *
   * @generated from field: repeated geneo.lms.db.CloudUpload user_uploads = 10;
   */
  userUploads: CloudUpload[] = [];

  /**
   * @generated from field: repeated geneo.lms.db.StudentPracticalResponse practical_responses = 11;
   */
  practicalResponses: StudentPracticalResponse[] = [];

  /**
   * What the student did inside the coding editor. Unset when the events
   * service has nothing for this project, or could not be reached.
   *
   * LOGIN-BASED. In the lab a group shares one device and one login, so this
   * holds the device's work only for the member who was logged in. Show
   * group_work on a collaborative project.
   *
   * @generated from field: optional geneo.lms.assessment.student.apis.GilCodingActivity coding_activity = 12;
   */
  codingActivity?: GilCodingActivity;

  /**
   * Set only for a collaborative project: the work of the device the group
   * shares, credited to every member.
   *
   * @generated from field: optional geneo.lms.assessment.student.apis.GilGroupWork group_work = 13;
   */
  groupWork?: GilGroupWork;

  /**
   * @generated from field: geneo.lms.assessment.student.apis.GilDataStatus data_status = 14;
   */
  dataStatus?: GilDataStatus;

  /**
   * Inferred learning outcome performance on this project, in resource
   * sequence order; see GilLearningOutcomeScore. Empty when the project's
   * resources carry no learning outcomes.
   *
   * @generated from field: repeated geneo.lms.assessment.student.apis.GilLearningOutcomeScore learning_outcomes = 15;
   */
  learningOutcomes: GilLearningOutcomeScore[] = [];

  constructor(data?: PartialMessage<GilStudentProjectReport>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "geneo.lms.assessment.student.apis.GilStudentProjectReport";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "project", kind: "message", T: GilProjectInfo },
    { no: 2, name: "student_id", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 3, name: "student_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "class_section", kind: "message", T: GilClassSectionInfo },
    { no: 5, name: "student_group_id", kind: "scalar", T: 3 /* ScalarType.INT64 */, opt: true },
    { no: 6, name: "group_name", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 7, name: "status", kind: "enum", T: proto3.getEnumType(GilProjectStatusEnum) },
    { no: 8, name: "time_spent", kind: "message", T: GilTimeSpent },
    { no: 9, name: "project_score", kind: "message", T: GilProjectScore },
    { no: 10, name: "user_uploads", kind: "message", T: CloudUpload, repeated: true },
    { no: 11, name: "practical_responses", kind: "message", T: StudentPracticalResponse, repeated: true },
    { no: 12, name: "coding_activity", kind: "message", T: GilCodingActivity, opt: true },
    { no: 13, name: "group_work", kind: "message", T: GilGroupWork, opt: true },
    { no: 14, name: "data_status", kind: "message", T: GilDataStatus },
    { no: 15, name: "learning_outcomes", kind: "message", T: GilLearningOutcomeScore, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GilStudentProjectReport {
    return new GilStudentProjectReport().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GilStudentProjectReport {
    return new GilStudentProjectReport().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GilStudentProjectReport {
    return new GilStudentProjectReport().fromJsonString(jsonString, options);
  }

  static equals(a: GilStudentProjectReport | PlainMessage<GilStudentProjectReport> | undefined, b: GilStudentProjectReport | PlainMessage<GilStudentProjectReport> | undefined): boolean {
    return proto3.util.equals(GilStudentProjectReport, a, b);
  }
}

/**
 * @generated from message geneo.lms.assessment.student.apis.GetGilStudentProjectReportResponse
 */
export class GetGilStudentProjectReportResponse extends Message<GetGilStudentProjectReportResponse> {
  /**
   * @generated from field: int32 status = 1;
   */
  status = 0;

  /**
   * @generated from field: string code = 2;
   */
  code = "";

  /**
   * @generated from field: string message = 3;
   */
  message = "";

  /**
   * @generated from field: geneo.lms.assessment.student.apis.GilStudentProjectReport data = 4;
   */
  data?: GilStudentProjectReport;

  constructor(data?: PartialMessage<GetGilStudentProjectReportResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "geneo.lms.assessment.student.apis.GetGilStudentProjectReportResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "status", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 2, name: "code", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "message", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "data", kind: "message", T: GilStudentProjectReport },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetGilStudentProjectReportResponse {
    return new GetGilStudentProjectReportResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetGilStudentProjectReportResponse {
    return new GetGilStudentProjectReportResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetGilStudentProjectReportResponse {
    return new GetGilStudentProjectReportResponse().fromJsonString(jsonString, options);
  }

  static equals(a: GetGilStudentProjectReportResponse | PlainMessage<GetGilStudentProjectReportResponse> | undefined, b: GetGilStudentProjectReportResponse | PlainMessage<GetGilStudentProjectReportResponse> | undefined): boolean {
    return proto3.util.equals(GetGilStudentProjectReportResponse, a, b);
  }
}

/**
 * Dashboard 2 - one student, all projects.
 *
 * @generated from message geneo.lms.assessment.student.apis.GetGilStudentJourneyReportRequest
 */
export class GetGilStudentJourneyReportRequest extends Message<GetGilStudentJourneyReportRequest> {
  /**
   * @generated from field: int64 student_id = 1;
   */
  studentId = protoInt64.zero;

  /**
   * Defaults to the academic year of the student's current class section.
   *
   * @generated from field: optional int32 academic_year_id = 2;
   */
  academicYearId?: number;

  constructor(data?: PartialMessage<GetGilStudentJourneyReportRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "geneo.lms.assessment.student.apis.GetGilStudentJourneyReportRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "student_id", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 2, name: "academic_year_id", kind: "scalar", T: 5 /* ScalarType.INT32 */, opt: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetGilStudentJourneyReportRequest {
    return new GetGilStudentJourneyReportRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetGilStudentJourneyReportRequest {
    return new GetGilStudentJourneyReportRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetGilStudentJourneyReportRequest {
    return new GetGilStudentJourneyReportRequest().fromJsonString(jsonString, options);
  }

  static equals(a: GetGilStudentJourneyReportRequest | PlainMessage<GetGilStudentJourneyReportRequest> | undefined, b: GetGilStudentJourneyReportRequest | PlainMessage<GetGilStudentJourneyReportRequest> | undefined): boolean {
    return proto3.util.equals(GetGilStudentJourneyReportRequest, a, b);
  }
}

/**
 * @generated from message geneo.lms.assessment.student.apis.GilStudentProjectRow
 */
export class GilStudentProjectRow extends Message<GilStudentProjectRow> {
  /**
   * @generated from field: geneo.lms.assessment.student.apis.GilProjectInfo project = 1;
   */
  project?: GilProjectInfo;

  /**
   * @generated from field: geneo.lms.assessment.student.apis.GilProjectStatusEnum status = 2;
   */
  status = GilProjectStatusEnum.GIL_PROJECT_STATUS_UNDEFINED;

  /**
   * @generated from field: geneo.lms.assessment.student.apis.GilTimeSpent time_spent = 3;
   */
  timeSpent?: GilTimeSpent;

  /**
   * @generated from field: geneo.lms.assessment.student.apis.GilProjectScore project_score = 4;
   */
  projectScore?: GilProjectScore;

  /**
   * @generated from field: optional int64 student_group_id = 5;
   */
  studentGroupId?: bigint;

  /**
   * @generated from field: optional string group_name = 6;
   */
  groupName?: string;

  /**
   * Login-based; see GilStudentProjectReport.coding_activity.
   *
   * @generated from field: optional geneo.lms.assessment.student.apis.GilCodingActivity coding_activity = 7;
   */
  codingActivity?: GilCodingActivity;

  /**
   * Set only for a collaborative project.
   *
   * @generated from field: optional geneo.lms.assessment.student.apis.GilGroupWork group_work = 8;
   */
  groupWork?: GilGroupWork;

  constructor(data?: PartialMessage<GilStudentProjectRow>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "geneo.lms.assessment.student.apis.GilStudentProjectRow";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "project", kind: "message", T: GilProjectInfo },
    { no: 2, name: "status", kind: "enum", T: proto3.getEnumType(GilProjectStatusEnum) },
    { no: 3, name: "time_spent", kind: "message", T: GilTimeSpent },
    { no: 4, name: "project_score", kind: "message", T: GilProjectScore },
    { no: 5, name: "student_group_id", kind: "scalar", T: 3 /* ScalarType.INT64 */, opt: true },
    { no: 6, name: "group_name", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 7, name: "coding_activity", kind: "message", T: GilCodingActivity, opt: true },
    { no: 8, name: "group_work", kind: "message", T: GilGroupWork, opt: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GilStudentProjectRow {
    return new GilStudentProjectRow().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GilStudentProjectRow {
    return new GilStudentProjectRow().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GilStudentProjectRow {
    return new GilStudentProjectRow().fromJsonString(jsonString, options);
  }

  static equals(a: GilStudentProjectRow | PlainMessage<GilStudentProjectRow> | undefined, b: GilStudentProjectRow | PlainMessage<GilStudentProjectRow> | undefined): boolean {
    return proto3.util.equals(GilStudentProjectRow, a, b);
  }
}

/**
 * @generated from message geneo.lms.assessment.student.apis.GilStudentJourneySummary
 */
export class GilStudentJourneySummary extends Message<GilStudentJourneySummary> {
  /**
   * "8/10" on the dashboard is projects_completed / projects_assigned.
   *
   * @generated from field: int32 projects_completed = 1;
   */
  projectsCompleted = 0;

  /**
   * @generated from field: int32 projects_assigned = 2;
   */
  projectsAssigned = 0;

  /**
   * @generated from field: geneo.lms.assessment.student.apis.GilTimeSpent total_time_spent = 3;
   */
  totalTimeSpent?: GilTimeSpent;

  /**
   * Mean of obtained/max over graded projects only. Absent when none is graded.
   *
   * @generated from field: optional float avg_project_score_percent = 4;
   */
  avgProjectScorePercent?: number;

  /**
   * The student's coding work across every project of the year. active_student_count
   * is 1 or 0 here - it is one student - so the averages read as per-project
   * means over the projects they actually coded in.
   *
   * Login-based: only sittings opened under this student's own login.
   *
   * @generated from field: optional geneo.lms.assessment.student.apis.GilCodingSummary coding_summary = 5;
   */
  codingSummary?: GilCodingSummary;

  /**
   * Credited work: the student's own on individual projects plus their
   * group's shared device on collaborative ones. What the journey should show.
   *
   * @generated from field: geneo.lms.assessment.student.apis.GilTimeSpent credited_time_spent = 6;
   */
  creditedTimeSpent?: GilTimeSpent;

  /**
   * @generated from field: optional geneo.lms.assessment.student.apis.GilCodingSummary credited_coding_summary = 7;
   */
  creditedCodingSummary?: GilCodingSummary;

  constructor(data?: PartialMessage<GilStudentJourneySummary>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "geneo.lms.assessment.student.apis.GilStudentJourneySummary";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "projects_completed", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 2, name: "projects_assigned", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 3, name: "total_time_spent", kind: "message", T: GilTimeSpent },
    { no: 4, name: "avg_project_score_percent", kind: "scalar", T: 2 /* ScalarType.FLOAT */, opt: true },
    { no: 5, name: "coding_summary", kind: "message", T: GilCodingSummary, opt: true },
    { no: 6, name: "credited_time_spent", kind: "message", T: GilTimeSpent },
    { no: 7, name: "credited_coding_summary", kind: "message", T: GilCodingSummary, opt: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GilStudentJourneySummary {
    return new GilStudentJourneySummary().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GilStudentJourneySummary {
    return new GilStudentJourneySummary().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GilStudentJourneySummary {
    return new GilStudentJourneySummary().fromJsonString(jsonString, options);
  }

  static equals(a: GilStudentJourneySummary | PlainMessage<GilStudentJourneySummary> | undefined, b: GilStudentJourneySummary | PlainMessage<GilStudentJourneySummary> | undefined): boolean {
    return proto3.util.equals(GilStudentJourneySummary, a, b);
  }
}

/**
 * @generated from message geneo.lms.assessment.student.apis.GilStudentJourneyReport
 */
export class GilStudentJourneyReport extends Message<GilStudentJourneyReport> {
  /**
   * @generated from field: int64 student_id = 1;
   */
  studentId = protoInt64.zero;

  /**
   * @generated from field: string student_name = 2;
   */
  studentName = "";

  /**
   * @generated from field: geneo.lms.assessment.student.apis.GilClassSectionInfo class_section = 3;
   */
  classSection?: GilClassSectionInfo;

  /**
   * @generated from field: geneo.lms.assessment.student.apis.GilStudentJourneySummary summary = 4;
   */
  summary?: GilStudentJourneySummary;

  /**
   * Ordered by chapter number, then assignment date.
   *
   * @generated from field: repeated geneo.lms.assessment.student.apis.GilStudentProjectRow projects = 5;
   */
  projects: GilStudentProjectRow[] = [];

  /**
   * @generated from field: repeated geneo.lms.assessment.student.apis.GilGalleryItem gallery = 6;
   */
  gallery: GilGalleryItem[] = [];

  /**
   * @generated from field: geneo.lms.assessment.student.apis.GilDataStatus data_status = 7;
   */
  dataStatus?: GilDataStatus;

  /**
   * Inferred learning outcome performance across the year's projects; see
   * GilLearningOutcomeScore.
   *
   * @generated from field: repeated geneo.lms.assessment.student.apis.GilLearningOutcomeScore learning_outcomes = 8;
   */
  learningOutcomes: GilLearningOutcomeScore[] = [];

  constructor(data?: PartialMessage<GilStudentJourneyReport>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "geneo.lms.assessment.student.apis.GilStudentJourneyReport";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "student_id", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 2, name: "student_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "class_section", kind: "message", T: GilClassSectionInfo },
    { no: 4, name: "summary", kind: "message", T: GilStudentJourneySummary },
    { no: 5, name: "projects", kind: "message", T: GilStudentProjectRow, repeated: true },
    { no: 6, name: "gallery", kind: "message", T: GilGalleryItem, repeated: true },
    { no: 7, name: "data_status", kind: "message", T: GilDataStatus },
    { no: 8, name: "learning_outcomes", kind: "message", T: GilLearningOutcomeScore, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GilStudentJourneyReport {
    return new GilStudentJourneyReport().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GilStudentJourneyReport {
    return new GilStudentJourneyReport().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GilStudentJourneyReport {
    return new GilStudentJourneyReport().fromJsonString(jsonString, options);
  }

  static equals(a: GilStudentJourneyReport | PlainMessage<GilStudentJourneyReport> | undefined, b: GilStudentJourneyReport | PlainMessage<GilStudentJourneyReport> | undefined): boolean {
    return proto3.util.equals(GilStudentJourneyReport, a, b);
  }
}

/**
 * @generated from message geneo.lms.assessment.student.apis.GetGilStudentJourneyReportResponse
 */
export class GetGilStudentJourneyReportResponse extends Message<GetGilStudentJourneyReportResponse> {
  /**
   * @generated from field: int32 status = 1;
   */
  status = 0;

  /**
   * @generated from field: string code = 2;
   */
  code = "";

  /**
   * @generated from field: string message = 3;
   */
  message = "";

  /**
   * @generated from field: geneo.lms.assessment.student.apis.GilStudentJourneyReport data = 4;
   */
  data?: GilStudentJourneyReport;

  constructor(data?: PartialMessage<GetGilStudentJourneyReportResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "geneo.lms.assessment.student.apis.GetGilStudentJourneyReportResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "status", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 2, name: "code", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "message", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "data", kind: "message", T: GilStudentJourneyReport },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetGilStudentJourneyReportResponse {
    return new GetGilStudentJourneyReportResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetGilStudentJourneyReportResponse {
    return new GetGilStudentJourneyReportResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetGilStudentJourneyReportResponse {
    return new GetGilStudentJourneyReportResponse().fromJsonString(jsonString, options);
  }

  static equals(a: GetGilStudentJourneyReportResponse | PlainMessage<GetGilStudentJourneyReportResponse> | undefined, b: GetGilStudentJourneyReportResponse | PlainMessage<GetGilStudentJourneyReportResponse> | undefined): boolean {
    return proto3.util.equals(GetGilStudentJourneyReportResponse, a, b);
  }
}

/**
 * @generated from message geneo.lms.assessment.student.apis.GilErrorClassCount
 */
export class GilErrorClassCount extends Message<GilErrorClassCount> {
  /**
   * The editor's own classification - never raw error text.
   *
   * @generated from field: string error_class = 1;
   */
  errorClass = "";

  /**
   * @generated from field: int32 count = 2;
   */
  count = 0;

  constructor(data?: PartialMessage<GilErrorClassCount>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "geneo.lms.assessment.student.apis.GilErrorClassCount";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "error_class", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "count", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GilErrorClassCount {
    return new GilErrorClassCount().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GilErrorClassCount {
    return new GilErrorClassCount().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GilErrorClassCount {
    return new GilErrorClassCount().fromJsonString(jsonString, options);
  }

  static equals(a: GilErrorClassCount | PlainMessage<GilErrorClassCount> | undefined, b: GilErrorClassCount | PlainMessage<GilErrorClassCount> | undefined): boolean {
    return proto3.util.equals(GilErrorClassCount, a, b);
  }
}

/**
 * One student's work inside the coding editor, for one project.
 *
 * @generated from message geneo.lms.assessment.student.apis.GilCodingActivity
 */
export class GilCodingActivity extends Message<GilCodingActivity> {
  /**
   * Tab-focused editor time, summed over the sitting's editor sessions. The
   * honest counterpart to GilTimeSpent.coding_time_in_sec, which is wall clock
   * between opening and closing the resource.
   *
   * @generated from field: float active_coding_time_in_sec = 1;
   */
  activeCodingTimeInSec = 0;

  /**
   * @generated from field: int32 editor_session_count = 2;
   */
  editorSessionCount = 0;

  /**
   * Simulator.
   *
   * @generated from field: int32 sim_run_count = 3;
   */
  simRunCount = 0;

  /**
   * @generated from field: int32 sim_success_count = 4;
   */
  simSuccessCount = 0;

  /**
   * @generated from field: float sim_total_time_in_sec = 5;
   */
  simTotalTimeInSec = 0;

  /**
   * Physical device. compile_* is Arduino only; a MicroPython board flashes
   * without a compile step, so its compile counts stay zero.
   *
   * @generated from field: int32 device_connect_attempt_count = 6;
   */
  deviceConnectAttemptCount = 0;

  /**
   * @generated from field: int32 device_connect_success_count = 7;
   */
  deviceConnectSuccessCount = 0;

  /**
   * serial | bluetooth | webrepl
   *
   * @generated from field: repeated string transports_used = 8;
   */
  transportsUsed: string[] = [];

  /**
   * @generated from field: int32 compile_attempt_count = 9;
   */
  compileAttemptCount = 0;

  /**
   * @generated from field: int32 compile_success_count = 10;
   */
  compileSuccessCount = 0;

  /**
   * @generated from field: int32 flash_attempt_count = 11;
   */
  flashAttemptCount = 0;

  /**
   * @generated from field: int32 flash_success_count = 12;
   */
  flashSuccessCount = 0;

  /**
   * True once anything reached real hardware, which is the outcome GIL exists
   * for and the one a teacher most wants to see.
   *
   * @generated from field: bool ran_on_hardware = 13;
   */
  ranOnHardware = false;

  /**
   * The artefact, taken from the sitting's LAST workspace snapshot and save -
   * a census of what the student ended up with, not a sum over edits.
   *
   * @generated from field: int32 project_save_count = 14;
   */
  projectSaveCount = 0;

  /**
   * @generated from field: int32 block_count = 15;
   */
  blockCount = 0;

  /**
   * @generated from field: int32 max_block_depth = 16;
   */
  maxBlockDepth = 0;

  /**
   * @generated from field: int32 code_lines = 17;
   */
  codeLines = 0;

  /**
   * blocks | code
   *
   * @generated from field: optional string editor_mode = 18;
   */
  editorMode?: string;

  /**
   * esp32 | esp8266 | arduino_uno | ...
   *
   * @generated from field: optional string board = 19;
   */
  board?: string;

  /**
   * Computational-thinking indicators: whether the finished program ever used
   * each construct. Cheap to collect and the closest thing the stream gives to
   * a measure of what was actually learned.
   *
   * @generated from field: bool uses_loop = 20;
   */
  usesLoop = false;

  /**
   * @generated from field: bool uses_condition = 21;
   */
  usesCondition = false;

  /**
   * @generated from field: bool uses_variable = 22;
   */
  usesVariable = false;

  /**
   * @generated from field: bool uses_function = 23;
   */
  usesFunction = false;

  /**
   * Friction: error toasts and console errors shown inside the editor.
   *
   * @generated from field: int32 error_count = 24;
   */
  errorCount = 0;

  /**
   * Most frequent first, capped by the events service.
   *
   * @generated from field: repeated geneo.lms.assessment.student.apis.GilErrorClassCount top_errors = 25;
   */
  topErrors: GilErrorClassCount[] = [];

  constructor(data?: PartialMessage<GilCodingActivity>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "geneo.lms.assessment.student.apis.GilCodingActivity";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "active_coding_time_in_sec", kind: "scalar", T: 2 /* ScalarType.FLOAT */ },
    { no: 2, name: "editor_session_count", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 3, name: "sim_run_count", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 4, name: "sim_success_count", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 5, name: "sim_total_time_in_sec", kind: "scalar", T: 2 /* ScalarType.FLOAT */ },
    { no: 6, name: "device_connect_attempt_count", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 7, name: "device_connect_success_count", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 8, name: "transports_used", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 9, name: "compile_attempt_count", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 10, name: "compile_success_count", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 11, name: "flash_attempt_count", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 12, name: "flash_success_count", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 13, name: "ran_on_hardware", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 14, name: "project_save_count", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 15, name: "block_count", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 16, name: "max_block_depth", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 17, name: "code_lines", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 18, name: "editor_mode", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 19, name: "board", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 20, name: "uses_loop", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 21, name: "uses_condition", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 22, name: "uses_variable", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 23, name: "uses_function", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 24, name: "error_count", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 25, name: "top_errors", kind: "message", T: GilErrorClassCount, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GilCodingActivity {
    return new GilCodingActivity().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GilCodingActivity {
    return new GilCodingActivity().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GilCodingActivity {
    return new GilCodingActivity().fromJsonString(jsonString, options);
  }

  static equals(a: GilCodingActivity | PlainMessage<GilCodingActivity> | undefined, b: GilCodingActivity | PlainMessage<GilCodingActivity> | undefined): boolean {
    return proto3.util.equals(GilCodingActivity, a, b);
  }
}

/**
 * GilCodingActivity rolled up over a group, a class or a school.
 *
 * Rates are deliberately split by denominator, because the two answer
 * different questions: *_rate_percent is per attempt ("does the hardware
 * work?"), *_student_percent is per student ("how many children got there?").
 *
 * @generated from message geneo.lms.assessment.student.apis.GilCodingSummary
 */
export class GilCodingSummary extends Message<GilCodingSummary> {
  /**
   * Students with any editor activity at all. Every average below is over
   * these, never over the roster - an untouched project must not read as a
   * class that codes for zero minutes.
   *
   * LOGIN-BASED: on a shared lab device only the logged-in member has editor
   * activity, so this counts active devices (roughly, groups) rather than
   * children, and every *_student_percent below is a share of those.
   *
   * @generated from field: int32 active_student_count = 1;
   */
  activeStudentCount = 0;

  /**
   * @generated from field: float total_active_coding_time_in_sec = 2;
   */
  totalActiveCodingTimeInSec = 0;

  /**
   * @generated from field: float avg_active_coding_time_in_sec = 3;
   */
  avgActiveCodingTimeInSec = 0;

  /**
   * @generated from field: int32 sim_run_count = 4;
   */
  simRunCount = 0;

  /**
   * @generated from field: optional float sim_success_rate_percent = 5;
   */
  simSuccessRatePercent?: number;

  /**
   * @generated from field: int32 flash_attempt_count = 6;
   */
  flashAttemptCount = 0;

  /**
   * @generated from field: optional float flash_success_rate_percent = 7;
   */
  flashSuccessRatePercent?: number;

  /**
   * Share of active students who got code onto a real board.
   *
   * @generated from field: float ran_on_hardware_student_percent = 8;
   */
  ranOnHardwareStudentPercent = 0;

  /**
   * @generated from field: float avg_block_count = 9;
   */
  avgBlockCount = 0;

  /**
   * Share of active students whose program used each construct.
   *
   * @generated from field: float uses_loop_student_percent = 10;
   */
  usesLoopStudentPercent = 0;

  /**
   * @generated from field: float uses_condition_student_percent = 11;
   */
  usesConditionStudentPercent = 0;

  /**
   * @generated from field: float uses_variable_student_percent = 12;
   */
  usesVariableStudentPercent = 0;

  /**
   * @generated from field: float uses_function_student_percent = 13;
   */
  usesFunctionStudentPercent = 0;

  /**
   * @generated from field: int32 error_count = 14;
   */
  errorCount = 0;

  /**
   * @generated from field: repeated geneo.lms.assessment.student.apis.GilErrorClassCount top_errors = 15;
   */
  topErrors: GilErrorClassCount[] = [];

  /**
   * Of the active students with at least one successful simulator run, the
   * share who also got code onto a real board. Absent when nobody succeeded in
   * the simulator.
   *
   * @generated from field: optional float sim_to_hardware_percent = 16;
   */
  simToHardwarePercent?: number;

  /**
   * Arduino only (MicroPython has no compile step). Absent with no attempts.
   *
   * @generated from field: int32 compile_attempt_count = 17;
   */
  compileAttemptCount = 0;

  /**
   * @generated from field: optional float compile_success_rate_percent = 18;
   */
  compileSuccessRatePercent?: number;

  /**
   * Editor errors per hour of active coding. Absent with no active time.
   *
   * @generated from field: optional float errors_per_active_hour = 19;
   */
  errorsPerActiveHour?: number;

  /**
   * Active students stuck on the hardware: at least 3 failed connects or
   * flashes and no successful flash.
   *
   * @generated from field: int32 hardware_blocked_count = 20;
   */
  hardwareBlockedCount = 0;

  constructor(data?: PartialMessage<GilCodingSummary>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "geneo.lms.assessment.student.apis.GilCodingSummary";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "active_student_count", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 2, name: "total_active_coding_time_in_sec", kind: "scalar", T: 2 /* ScalarType.FLOAT */ },
    { no: 3, name: "avg_active_coding_time_in_sec", kind: "scalar", T: 2 /* ScalarType.FLOAT */ },
    { no: 4, name: "sim_run_count", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 5, name: "sim_success_rate_percent", kind: "scalar", T: 2 /* ScalarType.FLOAT */, opt: true },
    { no: 6, name: "flash_attempt_count", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 7, name: "flash_success_rate_percent", kind: "scalar", T: 2 /* ScalarType.FLOAT */, opt: true },
    { no: 8, name: "ran_on_hardware_student_percent", kind: "scalar", T: 2 /* ScalarType.FLOAT */ },
    { no: 9, name: "avg_block_count", kind: "scalar", T: 2 /* ScalarType.FLOAT */ },
    { no: 10, name: "uses_loop_student_percent", kind: "scalar", T: 2 /* ScalarType.FLOAT */ },
    { no: 11, name: "uses_condition_student_percent", kind: "scalar", T: 2 /* ScalarType.FLOAT */ },
    { no: 12, name: "uses_variable_student_percent", kind: "scalar", T: 2 /* ScalarType.FLOAT */ },
    { no: 13, name: "uses_function_student_percent", kind: "scalar", T: 2 /* ScalarType.FLOAT */ },
    { no: 14, name: "error_count", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 15, name: "top_errors", kind: "message", T: GilErrorClassCount, repeated: true },
    { no: 16, name: "sim_to_hardware_percent", kind: "scalar", T: 2 /* ScalarType.FLOAT */, opt: true },
    { no: 17, name: "compile_attempt_count", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 18, name: "compile_success_rate_percent", kind: "scalar", T: 2 /* ScalarType.FLOAT */, opt: true },
    { no: 19, name: "errors_per_active_hour", kind: "scalar", T: 2 /* ScalarType.FLOAT */, opt: true },
    { no: 20, name: "hardware_blocked_count", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GilCodingSummary {
    return new GilCodingSummary().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GilCodingSummary {
    return new GilCodingSummary().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GilCodingSummary {
    return new GilCodingSummary().fromJsonString(jsonString, options);
  }

  static equals(a: GilCodingSummary | PlainMessage<GilCodingSummary> | undefined, b: GilCodingSummary | PlainMessage<GilCodingSummary> | undefined): boolean {
    return proto3.util.equals(GilCodingSummary, a, b);
  }
}

/**
 * The work of the device a collaboration group shares, credited to every member.
 *
 * @generated from message geneo.lms.assessment.student.apis.GilGroupWork
 */
export class GilGroupWork extends Message<GilGroupWork> {
  /**
   * @generated from field: int64 student_group_id = 1;
   */
  studentGroupId = protoInt64.zero;

  /**
   * @generated from field: optional string group_name = 2;
   */
  groupName?: string;

  /**
   * @generated from field: int32 member_count = 3;
   */
  memberCount = 0;

  /**
   * Every member's sittings on the project, summed.
   *
   * @generated from field: geneo.lms.assessment.student.apis.GilTimeSpent time_spent = 4;
   */
  timeSpent?: GilTimeSpent;

  /**
   * Every member's editor telemetry on the project, merged. Unset when the
   * events service has nothing for the group or could not be reached.
   *
   * @generated from field: optional geneo.lms.assessment.student.apis.GilCodingActivity coding_activity = 5;
   */
  codingActivity?: GilCodingActivity;

  constructor(data?: PartialMessage<GilGroupWork>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "geneo.lms.assessment.student.apis.GilGroupWork";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "student_group_id", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 2, name: "group_name", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 3, name: "member_count", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 4, name: "time_spent", kind: "message", T: GilTimeSpent },
    { no: 5, name: "coding_activity", kind: "message", T: GilCodingActivity, opt: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GilGroupWork {
    return new GilGroupWork().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GilGroupWork {
    return new GilGroupWork().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GilGroupWork {
    return new GilGroupWork().fromJsonString(jsonString, options);
  }

  static equals(a: GilGroupWork | PlainMessage<GilGroupWork> | undefined, b: GilGroupWork | PlainMessage<GilGroupWork> | undefined): boolean {
    return proto3.util.equals(GilGroupWork, a, b);
  }
}

/**
 * Progress, pacing and grading figures derived from the assignment rows.
 * Counts of submissions and grades are per student (marks are individual);
 * start and stall figures are per work unit (the group shares a device).
 *
 * @generated from message geneo.lms.assessment.student.apis.GilProgressMetrics
 */
export class GilProgressMetrics extends Message<GilProgressMetrics> {
  /**
   * Submitted students with a due date / of those, submitted on or before it.
   *
   * @generated from field: int32 submitted_with_due_date_count = 1;
   */
  submittedWithDueDateCount = 0;

  /**
   * @generated from field: optional float on_time_completion_percent = 2;
   */
  onTimeCompletionPercent?: number;

  /**
   * Students past their due date who have not submitted.
   *
   * @generated from field: int32 overdue_count = 3;
   */
  overdueCount = 0;

  /**
   * Median days from assignment to the work unit's first sitting, over units
   * that have started.
   *
   * @generated from field: optional float median_days_to_start = 4;
   */
  medianDaysToStart?: number;

  /**
   * Work units with sittings, not submitted, and no sitting for 14 days.
   *
   * @generated from field: int32 stalled_group_count = 5;
   */
  stalledGroupCount = 0;

  /**
   * @generated from field: int32 submitted_count = 6;
   */
  submittedCount = 0;

  /**
   * Of the submitted students, the ones a teacher has reviewed.
   *
   * @generated from field: int32 graded_count = 7;
   */
  gradedCount = 0;

  /**
   * @generated from field: optional float graded_percent = 8;
   */
  gradedPercent?: number;

  /**
   * Of the graded students, the share whose review carries a remark.
   *
   * @generated from field: optional float remarks_percent = 9;
   */
  remarksPercent?: number;

  /**
   * Median hours from submission to the teacher's latest review.
   *
   * @generated from field: optional float median_grading_turnaround_hours = 10;
   */
  medianGradingTurnaroundHours?: number;

  constructor(data?: PartialMessage<GilProgressMetrics>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "geneo.lms.assessment.student.apis.GilProgressMetrics";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "submitted_with_due_date_count", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 2, name: "on_time_completion_percent", kind: "scalar", T: 2 /* ScalarType.FLOAT */, opt: true },
    { no: 3, name: "overdue_count", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 4, name: "median_days_to_start", kind: "scalar", T: 2 /* ScalarType.FLOAT */, opt: true },
    { no: 5, name: "stalled_group_count", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 6, name: "submitted_count", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 7, name: "graded_count", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 8, name: "graded_percent", kind: "scalar", T: 2 /* ScalarType.FLOAT */, opt: true },
    { no: 9, name: "remarks_percent", kind: "scalar", T: 2 /* ScalarType.FLOAT */, opt: true },
    { no: 10, name: "median_grading_turnaround_hours", kind: "scalar", T: 2 /* ScalarType.FLOAT */, opt: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GilProgressMetrics {
    return new GilProgressMetrics().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GilProgressMetrics {
    return new GilProgressMetrics().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GilProgressMetrics {
    return new GilProgressMetrics().fromJsonString(jsonString, options);
  }

  static equals(a: GilProgressMetrics | PlainMessage<GilProgressMetrics> | undefined, b: GilProgressMetrics | PlainMessage<GilProgressMetrics> | undefined): boolean {
    return proto3.util.equals(GilProgressMetrics, a, b);
  }
}

/**
 * @generated from message geneo.lms.assessment.student.apis.GilStudentRef
 */
export class GilStudentRef extends Message<GilStudentRef> {
  /**
   * @generated from field: int64 student_id = 1;
   */
  studentId = protoInt64.zero;

  /**
   * @generated from field: string student_name = 2;
   */
  studentName = "";

  constructor(data?: PartialMessage<GilStudentRef>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "geneo.lms.assessment.student.apis.GilStudentRef";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "student_id", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 2, name: "student_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GilStudentRef {
    return new GilStudentRef().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GilStudentRef {
    return new GilStudentRef().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GilStudentRef {
    return new GilStudentRef().fromJsonString(jsonString, options);
  }

  static equals(a: GilStudentRef | PlainMessage<GilStudentRef> | undefined, b: GilStudentRef | PlainMessage<GilStudentRef> | undefined): boolean {
    return proto3.util.equals(GilStudentRef, a, b);
  }
}

/**
 * One thing a teacher can act on. Teacher-facing only.
 *
 * @generated from message geneo.lms.assessment.student.apis.GilAttentionItem
 */
export class GilAttentionItem extends Message<GilAttentionItem> {
  /**
   * @generated from field: geneo.lms.assessment.student.apis.GilAttentionTypeEnum type = 1;
   */
  type = GilAttentionTypeEnum.GIL_ATTENTION_TYPE_UNDEFINED;

  /**
   * @generated from field: int64 assessment_id = 2;
   */
  assessmentId = protoInt64.zero;

  /**
   * @generated from field: string project_title = 3;
   */
  projectTitle = "";

  /**
   * Set for a collaboration group; unset for a student on an individual project.
   *
   * @generated from field: optional int64 student_group_id = 4;
   */
  studentGroupId?: bigint;

  /**
   * @generated from field: optional string group_name = 5;
   */
  groupName?: string;

  /**
   * The students the item is about: the whole group, or for UNGRADED only the
   * members still to be reviewed.
   *
   * @generated from field: repeated geneo.lms.assessment.student.apis.GilStudentRef students = 6;
   */
  students: GilStudentRef[] = [];

  /**
   * When the condition began: assignment date, last sitting, due date or
   * submission date, by type.
   *
   * @generated from field: optional google.protobuf.Timestamp since = 7;
   */
  since?: Timestamp;

  constructor(data?: PartialMessage<GilAttentionItem>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "geneo.lms.assessment.student.apis.GilAttentionItem";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "type", kind: "enum", T: proto3.getEnumType(GilAttentionTypeEnum) },
    { no: 2, name: "assessment_id", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 3, name: "project_title", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "student_group_id", kind: "scalar", T: 3 /* ScalarType.INT64 */, opt: true },
    { no: 5, name: "group_name", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 6, name: "students", kind: "message", T: GilStudentRef, repeated: true },
    { no: 7, name: "since", kind: "message", T: Timestamp, opt: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GilAttentionItem {
    return new GilAttentionItem().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GilAttentionItem {
    return new GilAttentionItem().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GilAttentionItem {
    return new GilAttentionItem().fromJsonString(jsonString, options);
  }

  static equals(a: GilAttentionItem | PlainMessage<GilAttentionItem> | undefined, b: GilAttentionItem | PlainMessage<GilAttentionItem> | undefined): boolean {
    return proto3.util.equals(GilAttentionItem, a, b);
  }
}

/**
 * One week of a section's or school's GIL activity. Weeks start Monday 00:00
 * IST and are returned oldest first, gaps included as zero weeks.
 *
 * @generated from message geneo.lms.assessment.student.apis.GilWeeklyPoint
 */
export class GilWeeklyPoint extends Message<GilWeeklyPoint> {
  /**
   * @generated from field: google.protobuf.Timestamp week_start = 1;
   */
  weekStart?: Timestamp;

  /**
   * True for the current, unfinished week.
   *
   * @generated from field: bool is_partial = 2;
   */
  isPartial = false;

  /**
   * Students credited with a sitting this week through their work unit.
   *
   * @generated from field: int32 active_students = 3;
   */
  activeStudents = 0;

  /**
   * @generated from field: int32 active_groups = 4;
   */
  activeGroups = 0;

  /**
   * Weekly Active Builders: students credited with a successful simulator run
   * or flash this week. Unset when telemetry is unavailable - unknown is not 0.
   *
   * @generated from field: optional int32 active_builders = 5;
   */
  activeBuilders?: number;

  /**
   * @generated from field: optional int32 building_groups = 6;
   */
  buildingGroups?: number;

  /**
   * Students the report is about (the roster in scope), the denominator.
   *
   * @generated from field: int32 enrolled_students = 7;
   */
  enrolledStudents = 0;

  /**
   * @generated from field: optional float active_builders_percent = 8;
   */
  activeBuildersPercent?: number;

  /**
   * @generated from field: float total_time_in_sec = 9;
   */
  totalTimeInSec = 0;

  constructor(data?: PartialMessage<GilWeeklyPoint>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "geneo.lms.assessment.student.apis.GilWeeklyPoint";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "week_start", kind: "message", T: Timestamp },
    { no: 2, name: "is_partial", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 3, name: "active_students", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 4, name: "active_groups", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 5, name: "active_builders", kind: "scalar", T: 5 /* ScalarType.INT32 */, opt: true },
    { no: 6, name: "building_groups", kind: "scalar", T: 5 /* ScalarType.INT32 */, opt: true },
    { no: 7, name: "enrolled_students", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 8, name: "active_builders_percent", kind: "scalar", T: 2 /* ScalarType.FLOAT */, opt: true },
    { no: 9, name: "total_time_in_sec", kind: "scalar", T: 2 /* ScalarType.FLOAT */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GilWeeklyPoint {
    return new GilWeeklyPoint().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GilWeeklyPoint {
    return new GilWeeklyPoint().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GilWeeklyPoint {
    return new GilWeeklyPoint().fromJsonString(jsonString, options);
  }

  static equals(a: GilWeeklyPoint | PlainMessage<GilWeeklyPoint> | undefined, b: GilWeeklyPoint | PlainMessage<GilWeeklyPoint> | undefined): boolean {
    return proto3.util.equals(GilWeeklyPoint, a, b);
  }
}

/**
 * How complete and how fresh a report's data is. Coding data from an offline
 * school server arrives when it syncs, so a cloud-served report can be behind
 * the lab; this is what the dashboard shows so nobody reads a gap as a fact.
 *
 * @generated from message geneo.lms.assessment.student.apis.GilDataStatus
 */
export class GilDataStatus extends Message<GilDataStatus> {
  /**
   * @generated from field: google.protobuf.Timestamp generated_at = 1;
   */
  generatedAt?: Timestamp;

  /**
   * The newest sitting write in scope: when the lab last did anything.
   *
   * @generated from field: optional google.protobuf.Timestamp latest_activity_at = 2;
   */
  latestActivityAt?: Timestamp;

  /**
   * @generated from field: geneo.lms.assessment.student.apis.GilTelemetryStatusEnum telemetry_status = 3;
   */
  telemetryStatus = GilTelemetryStatusEnum.GIL_TELEMETRY_STATUS_UNDEFINED;

  /**
   * Sittings on coding (practical) resources / those with any editor event.
   *
   * @generated from field: int32 coding_sitting_count = 4;
   */
  codingSittingCount = 0;

  /**
   * @generated from field: int32 coding_sittings_with_telemetry_count = 5;
   */
  codingSittingsWithTelemetryCount = 0;

  /**
   * Absent when there are no coding sittings or telemetry is not available.
   *
   * @generated from field: optional float telemetry_coverage_percent = 6;
   */
  telemetryCoveragePercent?: number;

  constructor(data?: PartialMessage<GilDataStatus>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "geneo.lms.assessment.student.apis.GilDataStatus";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "generated_at", kind: "message", T: Timestamp },
    { no: 2, name: "latest_activity_at", kind: "message", T: Timestamp, opt: true },
    { no: 3, name: "telemetry_status", kind: "enum", T: proto3.getEnumType(GilTelemetryStatusEnum) },
    { no: 4, name: "coding_sitting_count", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 5, name: "coding_sittings_with_telemetry_count", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 6, name: "telemetry_coverage_percent", kind: "scalar", T: 2 /* ScalarType.FLOAT */, opt: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GilDataStatus {
    return new GilDataStatus().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GilDataStatus {
    return new GilDataStatus().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GilDataStatus {
    return new GilDataStatus().fromJsonString(jsonString, options);
  }

  static equals(a: GilDataStatus | PlainMessage<GilDataStatus> | undefined, b: GilDataStatus | PlainMessage<GilDataStatus> | undefined): boolean {
    return proto3.util.equals(GilDataStatus, a, b);
  }
}

/**
 * @generated from message geneo.lms.assessment.student.apis.GilLearningOutcomeScore
 */
export class GilLearningOutcomeScore extends Message<GilLearningOutcomeScore> {
  /**
   * @generated from field: string learning_outcome_id = 1;
   */
  learningOutcomeId = "";

  /**
   * @generated from field: string learning_outcome = 2;
   */
  learningOutcome = "";

  /**
   * @generated from field: optional string bloom_level = 3;
   */
  bloomLevel?: string;

  /**
   * Project resources tagged with this outcome, summed over the projects in
   * scope.
   *
   * @generated from field: int32 resource_count = 4;
   */
  resourceCount = 0;

  /**
   * Projects in scope that cover this outcome.
   *
   * @generated from field: int32 project_count = 5;
   */
  projectCount = 0;

  /**
   * (student, project) pairs averaged over, and the graded ones among them.
   *
   * @generated from field: int32 attempt_count = 6;
   */
  attemptCount = 0;

  /**
   * @generated from field: int32 graded_attempt_count = 7;
   */
  gradedAttemptCount = 0;

  /**
   * Mean share of the outcome's resources completed, 0-100.
   *
   * @generated from field: float completion_percent = 8;
   */
  completionPercent = 0;

  /**
   * Mean inferred score (score x completion), 0-100, over graded attempts only.
   * Absent when no attempt is graded.
   *
   * @generated from field: optional float inferred_score_percent = 9;
   */
  inferredScorePercent?: number;

  /**
   * One student, one project only: the project's max marks spread across its
   * outcomes by resource count, and this outcome's inferred share of the
   * obtained marks. inferred_marks is absent until the student is graded.
   *
   * @generated from field: optional float allocated_max_marks = 10;
   */
  allocatedMaxMarks?: number;

  /**
   * @generated from field: optional float inferred_marks = 11;
   */
  inferredMarks?: number;

  constructor(data?: PartialMessage<GilLearningOutcomeScore>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "geneo.lms.assessment.student.apis.GilLearningOutcomeScore";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "learning_outcome_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "learning_outcome", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "bloom_level", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 4, name: "resource_count", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 5, name: "project_count", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 6, name: "attempt_count", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 7, name: "graded_attempt_count", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 8, name: "completion_percent", kind: "scalar", T: 2 /* ScalarType.FLOAT */ },
    { no: 9, name: "inferred_score_percent", kind: "scalar", T: 2 /* ScalarType.FLOAT */, opt: true },
    { no: 10, name: "allocated_max_marks", kind: "scalar", T: 2 /* ScalarType.FLOAT */, opt: true },
    { no: 11, name: "inferred_marks", kind: "scalar", T: 2 /* ScalarType.FLOAT */, opt: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GilLearningOutcomeScore {
    return new GilLearningOutcomeScore().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GilLearningOutcomeScore {
    return new GilLearningOutcomeScore().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GilLearningOutcomeScore {
    return new GilLearningOutcomeScore().fromJsonString(jsonString, options);
  }

  static equals(a: GilLearningOutcomeScore | PlainMessage<GilLearningOutcomeScore> | undefined, b: GilLearningOutcomeScore | PlainMessage<GilLearningOutcomeScore> | undefined): boolean {
    return proto3.util.equals(GilLearningOutcomeScore, a, b);
  }
}

